/**
 * src/data/franchiseSubgroups.ts
 *
 * Direct sub-generator and sub-race links for each franchise universe.
 */

export interface SubgroupItem {
  name: string;
  fullName: string;
  slug: string;
  url: string;
}

export const FRANCHISE_SUBGROUPS: Record<string, SubgroupItem[]> = {
  "dnd-names": [
    {
      "name": "Dungeons & Dragons",
      "fullName": "Dungeons & Dragons",
      "slug": "dnd-names",
      "url": "/pop-culture/dnd-names"
    },
    {
      "name": "Aarakocra",
      "fullName": "Aarakocra",
      "slug": "dnd-aarakocra-names",
      "url": "/pop-culture/dnd-aarakocra-names"
    },
    {
      "name": "Aasimar",
      "fullName": "Aasimar",
      "slug": "dnd-aasimar-names",
      "url": "/pop-culture/dnd-aasimar-names"
    },
    {
      "name": "Bugbear",
      "fullName": "Bugbear",
      "slug": "dnd-bugbear-names",
      "url": "/pop-culture/dnd-bugbear-names"
    },
    {
      "name": "Centaur",
      "fullName": "Centaur",
      "slug": "dnd-centaur-names",
      "url": "/pop-culture/dnd-centaur-names"
    },
    {
      "name": "Changeling",
      "fullName": "Changeling",
      "slug": "dnd-changeling-names",
      "url": "/pop-culture/dnd-changeling-names"
    },
    {
      "name": "Deep Gnome",
      "fullName": "Deep Gnome",
      "slug": "dnd-deep-gnome-names",
      "url": "/pop-culture/dnd-deep-gnome-names"
    },
    {
      "name": "Deva",
      "fullName": "Deva",
      "slug": "dnd-deva-names",
      "url": "/pop-culture/dnd-deva-names"
    },
    {
      "name": "Dragonborn",
      "fullName": "Dragonborn",
      "slug": "dnd-dragonborn-names",
      "url": "/pop-culture/dnd-dragonborn-names"
    },
    {
      "name": "Drow",
      "fullName": "Drow",
      "slug": "dnd-drow-names",
      "url": "/pop-culture/dnd-drow-names"
    },
    {
      "name": "Duergar",
      "fullName": "Duergar",
      "slug": "dnd-duergar-names",
      "url": "/pop-culture/dnd-duergar-names"
    },
    {
      "name": "Dwarf",
      "fullName": "Dwarf",
      "slug": "dnd-dwarf-names",
      "url": "/pop-culture/dnd-dwarf-names"
    },
    {
      "name": "Eladrin",
      "fullName": "Eladrin",
      "slug": "dnd-eladrin-names",
      "url": "/pop-culture/dnd-eladrin-names"
    },
    {
      "name": "Elf",
      "fullName": "Elf",
      "slug": "dnd-elf-names",
      "url": "/pop-culture/dnd-elf-names"
    },
    {
      "name": "Fairy",
      "fullName": "Fairy",
      "slug": "dnd-fairy-names",
      "url": "/pop-culture/dnd-fairy-names"
    },
    {
      "name": "Firbolg",
      "fullName": "Firbolg",
      "slug": "dnd-firbolg-names",
      "url": "/pop-culture/dnd-firbolg-names"
    },
    {
      "name": "Genasi",
      "fullName": "Genasi",
      "slug": "dnd-genasi-names",
      "url": "/pop-culture/dnd-genasi-names"
    },
    {
      "name": "Githyanki",
      "fullName": "Githyanki",
      "slug": "dnd-githyanki-names",
      "url": "/pop-culture/dnd-githyanki-names"
    },
    {
      "name": "Githzerai",
      "fullName": "Githzerai",
      "slug": "dnd-githzerai-names",
      "url": "/pop-culture/dnd-githzerai-names"
    },
    {
      "name": "Gnome",
      "fullName": "Gnome",
      "slug": "dnd-gnome-names",
      "url": "/pop-culture/dnd-gnome-names"
    },
    {
      "name": "Goblin",
      "fullName": "Goblin",
      "slug": "dnd-goblin-names",
      "url": "/pop-culture/dnd-goblin-names"
    },
    {
      "name": "Goliath",
      "fullName": "Goliath",
      "slug": "dnd-goliath-names",
      "url": "/pop-culture/dnd-goliath-names"
    },
    {
      "name": "Grung",
      "fullName": "Grung",
      "slug": "dnd-grung-names",
      "url": "/pop-culture/dnd-grung-names"
    },
    {
      "name": "Half-Elf",
      "fullName": "Half-Elf",
      "slug": "dnd-half-elf-names",
      "url": "/pop-culture/dnd-half-elf-names"
    },
    {
      "name": "Half-Orc",
      "fullName": "Half-Orc",
      "slug": "dnd-half-orc-names",
      "url": "/pop-culture/dnd-half-orc-names"
    },
    {
      "name": "Halfling",
      "fullName": "Halfling",
      "slug": "dnd-halfling-names",
      "url": "/pop-culture/dnd-halfling-names"
    },
    {
      "name": "Harengon",
      "fullName": "Harengon",
      "slug": "dnd-harengon-names",
      "url": "/pop-culture/dnd-harengon-names"
    },
    {
      "name": "Hobgoblin",
      "fullName": "Hobgoblin",
      "slug": "dnd-hobgoblin-names",
      "url": "/pop-culture/dnd-hobgoblin-names"
    },
    {
      "name": "Human",
      "fullName": "Human",
      "slug": "dnd-human-names",
      "url": "/pop-culture/dnd-human-names"
    },
    {
      "name": "Kalashtar",
      "fullName": "Kalashtar",
      "slug": "dnd-kalashtar-names",
      "url": "/pop-culture/dnd-kalashtar-names"
    },
    {
      "name": "Kenku",
      "fullName": "Kenku",
      "slug": "dnd-kenku-names",
      "url": "/pop-culture/dnd-kenku-names"
    },
    {
      "name": "Kobold",
      "fullName": "Kobold",
      "slug": "dnd-kobold-names",
      "url": "/pop-culture/dnd-kobold-names"
    },
    {
      "name": "Leonin",
      "fullName": "Leonin",
      "slug": "dnd-leonin-names",
      "url": "/pop-culture/dnd-leonin-names"
    },
    {
      "name": "Lizardfolk",
      "fullName": "Lizardfolk",
      "slug": "dnd-lizardfolk-names",
      "url": "/pop-culture/dnd-lizardfolk-names"
    },
    {
      "name": "Locathah",
      "fullName": "Locathah",
      "slug": "dnd-locathah-names",
      "url": "/pop-culture/dnd-locathah-names"
    },
    {
      "name": "Loxodon",
      "fullName": "Loxodon",
      "slug": "dnd-loxodon-names",
      "url": "/pop-culture/dnd-loxodon-names"
    },
    {
      "name": "Minotaur",
      "fullName": "Minotaur",
      "slug": "dnd-minotaur-names",
      "url": "/pop-culture/dnd-minotaur-names"
    },
    {
      "name": "Orc",
      "fullName": "Orc",
      "slug": "dnd-orc-names",
      "url": "/pop-culture/dnd-orc-names"
    },
    {
      "name": "Satyr",
      "fullName": "Satyr",
      "slug": "dnd-satyr-names",
      "url": "/pop-culture/dnd-satyr-names"
    },
    {
      "name": "Shadar-Kai",
      "fullName": "Shadar-Kai",
      "slug": "dnd-shadar-kai-names",
      "url": "/pop-culture/dnd-shadar-kai-names"
    },
    {
      "name": "Shardmind",
      "fullName": "Shardmind",
      "slug": "dnd-shardmind-names",
      "url": "/pop-culture/dnd-shardmind-names"
    },
    {
      "name": "Shifter",
      "fullName": "Shifter",
      "slug": "dnd-shifter-names",
      "url": "/pop-culture/dnd-shifter-names"
    },
    {
      "name": "Simic Hybrid",
      "fullName": "Simic Hybrid",
      "slug": "dnd-simic-hybrid-names",
      "url": "/pop-culture/dnd-simic-hybrid-names"
    },
    {
      "name": "Tabaxi",
      "fullName": "Tabaxi",
      "slug": "dnd-tabaxi-names",
      "url": "/pop-culture/dnd-tabaxi-names"
    },
    {
      "name": "Tiefling",
      "fullName": "Tiefling",
      "slug": "dnd-tiefling-names",
      "url": "/pop-culture/dnd-tiefling-names"
    },
    {
      "name": "Tortle",
      "fullName": "Tortle",
      "slug": "dnd-tortle-names",
      "url": "/pop-culture/dnd-tortle-names"
    },
    {
      "name": "Triton",
      "fullName": "Triton",
      "slug": "dnd-triton-names",
      "url": "/pop-culture/dnd-triton-names"
    },
    {
      "name": "Vedalken",
      "fullName": "Vedalken",
      "slug": "dnd-vedalken-names",
      "url": "/pop-culture/dnd-vedalken-names"
    },
    {
      "name": "Verdan",
      "fullName": "Verdan",
      "slug": "dnd-verdan-names",
      "url": "/pop-culture/dnd-verdan-names"
    },
    {
      "name": "Warforged",
      "fullName": "Warforged",
      "slug": "dnd-warforged-names",
      "url": "/pop-culture/dnd-warforged-names"
    },
    {
      "name": "Wilden",
      "fullName": "Wilden",
      "slug": "dnd-wilden-names",
      "url": "/pop-culture/dnd-wilden-names"
    },
    {
      "name": "Yuan-Ti",
      "fullName": "Yuan-Ti",
      "slug": "dnd-yuan-ti-names",
      "url": "/pop-culture/dnd-yuan-ti-names"
    },
    {
      "name": "Archdevil",
      "fullName": "Archdevil",
      "slug": "dnd-archdevil-names",
      "url": "/pop-culture/dnd-archdevil-names"
    },
    {
      "name": "Archfey",
      "fullName": "Archfey",
      "slug": "dnd-archfey-names",
      "url": "/pop-culture/dnd-archfey-names"
    },
    {
      "name": "Beholder",
      "fullName": "Beholder",
      "slug": "dnd-beholder-names",
      "url": "/pop-culture/dnd-beholder-names"
    },
    {
      "name": "Bullywug",
      "fullName": "Bullywug",
      "slug": "dnd-bullywug-names",
      "url": "/pop-culture/dnd-bullywug-names"
    },
    {
      "name": "Demon Lord",
      "fullName": "Demon Lord",
      "slug": "dnd-demon-lord-names",
      "url": "/pop-culture/dnd-demon-lord-names"
    },
    {
      "name": "Dragon (Black)",
      "fullName": "Dragon (Black)",
      "slug": "dnd-black-dragon-names",
      "url": "/pop-culture/dnd-black-dragon-names"
    },
    {
      "name": "Dragon (Blue)",
      "fullName": "Dragon (Blue)",
      "slug": "dnd-blue-dragon-names",
      "url": "/pop-culture/dnd-blue-dragon-names"
    },
    {
      "name": "Dragon (Brass)",
      "fullName": "Dragon (Brass)",
      "slug": "dnd-brass-dragon-names",
      "url": "/pop-culture/dnd-brass-dragon-names"
    },
    {
      "name": "Dragon (Bronze)",
      "fullName": "Dragon (Bronze)",
      "slug": "dnd-bronze-dragon-names",
      "url": "/pop-culture/dnd-bronze-dragon-names"
    },
    {
      "name": "Dragon (Copper)",
      "fullName": "Dragon (Copper)",
      "slug": "dnd-copper-dragon-names",
      "url": "/pop-culture/dnd-copper-dragon-names"
    },
    {
      "name": "Dragon (Gold)",
      "fullName": "Dragon (Gold)",
      "slug": "dnd-gold-dragon-names",
      "url": "/pop-culture/dnd-gold-dragon-names"
    },
    {
      "name": "Dragon (Green)",
      "fullName": "Dragon (Green)",
      "slug": "dnd-green-dragon-names",
      "url": "/pop-culture/dnd-green-dragon-names"
    },
    {
      "name": "Dragon (Platinum)",
      "fullName": "Dragon (Platinum)",
      "slug": "dnd-platinum-dragon-names",
      "url": "/pop-culture/dnd-platinum-dragon-names"
    },
    {
      "name": "Dragon (Red)",
      "fullName": "Dragon (Red)",
      "slug": "dnd-red-dragon-names",
      "url": "/pop-culture/dnd-red-dragon-names"
    },
    {
      "name": "Dragon (Silver)",
      "fullName": "Dragon (Silver)",
      "slug": "dnd-silver-dragon-names",
      "url": "/pop-culture/dnd-silver-dragon-names"
    },
    {
      "name": "Dragon (White)",
      "fullName": "Dragon (White)",
      "slug": "dnd-white-dragon-names",
      "url": "/pop-culture/dnd-white-dragon-names"
    },
    {
      "name": "Genie",
      "fullName": "Genie",
      "slug": "dnd-genie-names",
      "url": "/pop-culture/dnd-genie-names"
    },
    {
      "name": "Giants",
      "fullName": "Giants",
      "slug": "dnd-giant-names",
      "url": "/pop-culture/dnd-giant-names"
    },
    {
      "name": "Gnoll",
      "fullName": "Gnoll",
      "slug": "dnd-gnoll-names",
      "url": "/pop-culture/dnd-gnoll-names"
    },
    {
      "name": "Hag",
      "fullName": "Hag",
      "slug": "dnd-hag-names",
      "url": "/pop-culture/dnd-hag-names"
    },
    {
      "name": "Mind Flayer",
      "fullName": "Mind Flayer",
      "slug": "dnd-mind-flayer-names",
      "url": "/pop-culture/dnd-mind-flayer-names"
    },
    {
      "name": "Myconid",
      "fullName": "Myconid",
      "slug": "dnd-myconid-names",
      "url": "/pop-culture/dnd-myconid-names"
    },
    {
      "name": "Ogre",
      "fullName": "Ogre",
      "slug": "dnd-ogre-names",
      "url": "/pop-culture/dnd-ogre-names"
    },
    {
      "name": "Pixie",
      "fullName": "Pixie",
      "slug": "dnd-pixie-names",
      "url": "/pop-culture/dnd-pixie-names"
    },
    {
      "name": "Treant",
      "fullName": "Treant",
      "slug": "dnd-treant-names",
      "url": "/pop-culture/dnd-treant-names"
    },
    {
      "name": "Troll",
      "fullName": "Troll",
      "slug": "dnd-troll-names",
      "url": "/pop-culture/dnd-troll-names"
    },
    {
      "name": "Troglodyte",
      "fullName": "Troglodyte",
      "slug": "dnd-troglodyte-names",
      "url": "/pop-culture/dnd-troglodyte-names"
    }
  ],
  "dnd-character-names": [
    {
      "name": "Dungeons & Dragons",
      "fullName": "Dungeons & Dragons",
      "slug": "dnd-names",
      "url": "/pop-culture/dnd-names"
    },
    {
      "name": "Aarakocra",
      "fullName": "Aarakocra",
      "slug": "dnd-aarakocra-names",
      "url": "/pop-culture/dnd-aarakocra-names"
    },
    {
      "name": "Aasimar",
      "fullName": "Aasimar",
      "slug": "dnd-aasimar-names",
      "url": "/pop-culture/dnd-aasimar-names"
    },
    {
      "name": "Bugbear",
      "fullName": "Bugbear",
      "slug": "dnd-bugbear-names",
      "url": "/pop-culture/dnd-bugbear-names"
    },
    {
      "name": "Centaur",
      "fullName": "Centaur",
      "slug": "dnd-centaur-names",
      "url": "/pop-culture/dnd-centaur-names"
    },
    {
      "name": "Changeling",
      "fullName": "Changeling",
      "slug": "dnd-changeling-names",
      "url": "/pop-culture/dnd-changeling-names"
    },
    {
      "name": "Deep Gnome",
      "fullName": "Deep Gnome",
      "slug": "dnd-deep-gnome-names",
      "url": "/pop-culture/dnd-deep-gnome-names"
    },
    {
      "name": "Deva",
      "fullName": "Deva",
      "slug": "dnd-deva-names",
      "url": "/pop-culture/dnd-deva-names"
    },
    {
      "name": "Dragonborn",
      "fullName": "Dragonborn",
      "slug": "dnd-dragonborn-names",
      "url": "/pop-culture/dnd-dragonborn-names"
    },
    {
      "name": "Drow",
      "fullName": "Drow",
      "slug": "dnd-drow-names",
      "url": "/pop-culture/dnd-drow-names"
    },
    {
      "name": "Duergar",
      "fullName": "Duergar",
      "slug": "dnd-duergar-names",
      "url": "/pop-culture/dnd-duergar-names"
    },
    {
      "name": "Dwarf",
      "fullName": "Dwarf",
      "slug": "dnd-dwarf-names",
      "url": "/pop-culture/dnd-dwarf-names"
    },
    {
      "name": "Eladrin",
      "fullName": "Eladrin",
      "slug": "dnd-eladrin-names",
      "url": "/pop-culture/dnd-eladrin-names"
    },
    {
      "name": "Elf",
      "fullName": "Elf",
      "slug": "dnd-elf-names",
      "url": "/pop-culture/dnd-elf-names"
    },
    {
      "name": "Fairy",
      "fullName": "Fairy",
      "slug": "dnd-fairy-names",
      "url": "/pop-culture/dnd-fairy-names"
    },
    {
      "name": "Firbolg",
      "fullName": "Firbolg",
      "slug": "dnd-firbolg-names",
      "url": "/pop-culture/dnd-firbolg-names"
    },
    {
      "name": "Genasi",
      "fullName": "Genasi",
      "slug": "dnd-genasi-names",
      "url": "/pop-culture/dnd-genasi-names"
    },
    {
      "name": "Githyanki",
      "fullName": "Githyanki",
      "slug": "dnd-githyanki-names",
      "url": "/pop-culture/dnd-githyanki-names"
    },
    {
      "name": "Githzerai",
      "fullName": "Githzerai",
      "slug": "dnd-githzerai-names",
      "url": "/pop-culture/dnd-githzerai-names"
    },
    {
      "name": "Gnome",
      "fullName": "Gnome",
      "slug": "dnd-gnome-names",
      "url": "/pop-culture/dnd-gnome-names"
    },
    {
      "name": "Goblin",
      "fullName": "Goblin",
      "slug": "dnd-goblin-names",
      "url": "/pop-culture/dnd-goblin-names"
    },
    {
      "name": "Goliath",
      "fullName": "Goliath",
      "slug": "dnd-goliath-names",
      "url": "/pop-culture/dnd-goliath-names"
    },
    {
      "name": "Grung",
      "fullName": "Grung",
      "slug": "dnd-grung-names",
      "url": "/pop-culture/dnd-grung-names"
    },
    {
      "name": "Half-Elf",
      "fullName": "Half-Elf",
      "slug": "dnd-half-elf-names",
      "url": "/pop-culture/dnd-half-elf-names"
    },
    {
      "name": "Half-Orc",
      "fullName": "Half-Orc",
      "slug": "dnd-half-orc-names",
      "url": "/pop-culture/dnd-half-orc-names"
    },
    {
      "name": "Halfling",
      "fullName": "Halfling",
      "slug": "dnd-halfling-names",
      "url": "/pop-culture/dnd-halfling-names"
    },
    {
      "name": "Harengon",
      "fullName": "Harengon",
      "slug": "dnd-harengon-names",
      "url": "/pop-culture/dnd-harengon-names"
    },
    {
      "name": "Hobgoblin",
      "fullName": "Hobgoblin",
      "slug": "dnd-hobgoblin-names",
      "url": "/pop-culture/dnd-hobgoblin-names"
    },
    {
      "name": "Human",
      "fullName": "Human",
      "slug": "dnd-human-names",
      "url": "/pop-culture/dnd-human-names"
    },
    {
      "name": "Kalashtar",
      "fullName": "Kalashtar",
      "slug": "dnd-kalashtar-names",
      "url": "/pop-culture/dnd-kalashtar-names"
    },
    {
      "name": "Kenku",
      "fullName": "Kenku",
      "slug": "dnd-kenku-names",
      "url": "/pop-culture/dnd-kenku-names"
    },
    {
      "name": "Kobold",
      "fullName": "Kobold",
      "slug": "dnd-kobold-names",
      "url": "/pop-culture/dnd-kobold-names"
    },
    {
      "name": "Leonin",
      "fullName": "Leonin",
      "slug": "dnd-leonin-names",
      "url": "/pop-culture/dnd-leonin-names"
    },
    {
      "name": "Lizardfolk",
      "fullName": "Lizardfolk",
      "slug": "dnd-lizardfolk-names",
      "url": "/pop-culture/dnd-lizardfolk-names"
    },
    {
      "name": "Locathah",
      "fullName": "Locathah",
      "slug": "dnd-locathah-names",
      "url": "/pop-culture/dnd-locathah-names"
    },
    {
      "name": "Loxodon",
      "fullName": "Loxodon",
      "slug": "dnd-loxodon-names",
      "url": "/pop-culture/dnd-loxodon-names"
    },
    {
      "name": "Minotaur",
      "fullName": "Minotaur",
      "slug": "dnd-minotaur-names",
      "url": "/pop-culture/dnd-minotaur-names"
    },
    {
      "name": "Orc",
      "fullName": "Orc",
      "slug": "dnd-orc-names",
      "url": "/pop-culture/dnd-orc-names"
    },
    {
      "name": "Satyr",
      "fullName": "Satyr",
      "slug": "dnd-satyr-names",
      "url": "/pop-culture/dnd-satyr-names"
    },
    {
      "name": "Shadar-Kai",
      "fullName": "Shadar-Kai",
      "slug": "dnd-shadar-kai-names",
      "url": "/pop-culture/dnd-shadar-kai-names"
    },
    {
      "name": "Shardmind",
      "fullName": "Shardmind",
      "slug": "dnd-shardmind-names",
      "url": "/pop-culture/dnd-shardmind-names"
    },
    {
      "name": "Shifter",
      "fullName": "Shifter",
      "slug": "dnd-shifter-names",
      "url": "/pop-culture/dnd-shifter-names"
    },
    {
      "name": "Simic Hybrid",
      "fullName": "Simic Hybrid",
      "slug": "dnd-simic-hybrid-names",
      "url": "/pop-culture/dnd-simic-hybrid-names"
    },
    {
      "name": "Tabaxi",
      "fullName": "Tabaxi",
      "slug": "dnd-tabaxi-names",
      "url": "/pop-culture/dnd-tabaxi-names"
    },
    {
      "name": "Tiefling",
      "fullName": "Tiefling",
      "slug": "dnd-tiefling-names",
      "url": "/pop-culture/dnd-tiefling-names"
    },
    {
      "name": "Tortle",
      "fullName": "Tortle",
      "slug": "dnd-tortle-names",
      "url": "/pop-culture/dnd-tortle-names"
    },
    {
      "name": "Triton",
      "fullName": "Triton",
      "slug": "dnd-triton-names",
      "url": "/pop-culture/dnd-triton-names"
    },
    {
      "name": "Vedalken",
      "fullName": "Vedalken",
      "slug": "dnd-vedalken-names",
      "url": "/pop-culture/dnd-vedalken-names"
    },
    {
      "name": "Verdan",
      "fullName": "Verdan",
      "slug": "dnd-verdan-names",
      "url": "/pop-culture/dnd-verdan-names"
    },
    {
      "name": "Warforged",
      "fullName": "Warforged",
      "slug": "dnd-warforged-names",
      "url": "/pop-culture/dnd-warforged-names"
    },
    {
      "name": "Wilden",
      "fullName": "Wilden",
      "slug": "dnd-wilden-names",
      "url": "/pop-culture/dnd-wilden-names"
    },
    {
      "name": "Yuan-Ti",
      "fullName": "Yuan-Ti",
      "slug": "dnd-yuan-ti-names",
      "url": "/pop-culture/dnd-yuan-ti-names"
    },
    {
      "name": "Archdevil",
      "fullName": "Archdevil",
      "slug": "dnd-archdevil-names",
      "url": "/pop-culture/dnd-archdevil-names"
    },
    {
      "name": "Archfey",
      "fullName": "Archfey",
      "slug": "dnd-archfey-names",
      "url": "/pop-culture/dnd-archfey-names"
    },
    {
      "name": "Beholder",
      "fullName": "Beholder",
      "slug": "dnd-beholder-names",
      "url": "/pop-culture/dnd-beholder-names"
    },
    {
      "name": "Bullywug",
      "fullName": "Bullywug",
      "slug": "dnd-bullywug-names",
      "url": "/pop-culture/dnd-bullywug-names"
    },
    {
      "name": "Demon Lord",
      "fullName": "Demon Lord",
      "slug": "dnd-demon-lord-names",
      "url": "/pop-culture/dnd-demon-lord-names"
    },
    {
      "name": "Dragon (Black)",
      "fullName": "Dragon (Black)",
      "slug": "dnd-black-dragon-names",
      "url": "/pop-culture/dnd-black-dragon-names"
    },
    {
      "name": "Dragon (Blue)",
      "fullName": "Dragon (Blue)",
      "slug": "dnd-blue-dragon-names",
      "url": "/pop-culture/dnd-blue-dragon-names"
    },
    {
      "name": "Dragon (Brass)",
      "fullName": "Dragon (Brass)",
      "slug": "dnd-brass-dragon-names",
      "url": "/pop-culture/dnd-brass-dragon-names"
    },
    {
      "name": "Dragon (Bronze)",
      "fullName": "Dragon (Bronze)",
      "slug": "dnd-bronze-dragon-names",
      "url": "/pop-culture/dnd-bronze-dragon-names"
    },
    {
      "name": "Dragon (Copper)",
      "fullName": "Dragon (Copper)",
      "slug": "dnd-copper-dragon-names",
      "url": "/pop-culture/dnd-copper-dragon-names"
    },
    {
      "name": "Dragon (Gold)",
      "fullName": "Dragon (Gold)",
      "slug": "dnd-gold-dragon-names",
      "url": "/pop-culture/dnd-gold-dragon-names"
    },
    {
      "name": "Dragon (Green)",
      "fullName": "Dragon (Green)",
      "slug": "dnd-green-dragon-names",
      "url": "/pop-culture/dnd-green-dragon-names"
    },
    {
      "name": "Dragon (Platinum)",
      "fullName": "Dragon (Platinum)",
      "slug": "dnd-platinum-dragon-names",
      "url": "/pop-culture/dnd-platinum-dragon-names"
    },
    {
      "name": "Dragon (Red)",
      "fullName": "Dragon (Red)",
      "slug": "dnd-red-dragon-names",
      "url": "/pop-culture/dnd-red-dragon-names"
    },
    {
      "name": "Dragon (Silver)",
      "fullName": "Dragon (Silver)",
      "slug": "dnd-silver-dragon-names",
      "url": "/pop-culture/dnd-silver-dragon-names"
    },
    {
      "name": "Dragon (White)",
      "fullName": "Dragon (White)",
      "slug": "dnd-white-dragon-names",
      "url": "/pop-culture/dnd-white-dragon-names"
    },
    {
      "name": "Genie",
      "fullName": "Genie",
      "slug": "dnd-genie-names",
      "url": "/pop-culture/dnd-genie-names"
    },
    {
      "name": "Giants",
      "fullName": "Giants",
      "slug": "dnd-giant-names",
      "url": "/pop-culture/dnd-giant-names"
    },
    {
      "name": "Gnoll",
      "fullName": "Gnoll",
      "slug": "dnd-gnoll-names",
      "url": "/pop-culture/dnd-gnoll-names"
    },
    {
      "name": "Hag",
      "fullName": "Hag",
      "slug": "dnd-hag-names",
      "url": "/pop-culture/dnd-hag-names"
    },
    {
      "name": "Mind Flayer",
      "fullName": "Mind Flayer",
      "slug": "dnd-mind-flayer-names",
      "url": "/pop-culture/dnd-mind-flayer-names"
    },
    {
      "name": "Myconid",
      "fullName": "Myconid",
      "slug": "dnd-myconid-names",
      "url": "/pop-culture/dnd-myconid-names"
    },
    {
      "name": "Ogre",
      "fullName": "Ogre",
      "slug": "dnd-ogre-names",
      "url": "/pop-culture/dnd-ogre-names"
    },
    {
      "name": "Pixie",
      "fullName": "Pixie",
      "slug": "dnd-pixie-names",
      "url": "/pop-culture/dnd-pixie-names"
    },
    {
      "name": "Treant",
      "fullName": "Treant",
      "slug": "dnd-treant-names",
      "url": "/pop-culture/dnd-treant-names"
    },
    {
      "name": "Troll",
      "fullName": "Troll",
      "slug": "dnd-troll-names",
      "url": "/pop-culture/dnd-troll-names"
    },
    {
      "name": "Troglodyte",
      "fullName": "Troglodyte",
      "slug": "dnd-troglodyte-names",
      "url": "/pop-culture/dnd-troglodyte-names"
    }
  ],
  "daggerheart-names": [
    {
      "name": "Dwarf",
      "fullName": "Dwarf",
      "slug": "daggerheart-dwarf-names",
      "url": "/pop-culture/daggerheart-dwarf-names"
    },
    {
      "name": "Elf",
      "fullName": "Elf",
      "slug": "daggerheart-elf-names",
      "url": "/pop-culture/daggerheart-elf-names"
    },
    {
      "name": "Faun",
      "fullName": "Faun",
      "slug": "daggerheart-faun-names",
      "url": "/pop-culture/daggerheart-faun-names"
    },
    {
      "name": "Giant",
      "fullName": "Giant",
      "slug": "daggerheart-giant-names",
      "url": "/pop-culture/daggerheart-giant-names"
    },
    {
      "name": "Goblin",
      "fullName": "Goblin",
      "slug": "daggerheart-goblin-names",
      "url": "/pop-culture/daggerheart-goblin-names"
    },
    {
      "name": "Orc",
      "fullName": "Orc",
      "slug": "daggerheart-orc-names",
      "url": "/pop-culture/daggerheart-orc-names"
    },
    {
      "name": "Clank",
      "fullName": "Clank",
      "slug": "daggerheart-clank-names",
      "url": "/pop-culture/daggerheart-clank-names"
    },
    {
      "name": "Drakona",
      "fullName": "Drakona",
      "slug": "daggerheart-drakona-names",
      "url": "/pop-culture/daggerheart-drakona-names"
    },
    {
      "name": "Faerie",
      "fullName": "Faerie",
      "slug": "daggerheart-faerie-names",
      "url": "/pop-culture/daggerheart-faerie-names"
    },
    {
      "name": "Firbolg",
      "fullName": "Firbolg",
      "slug": "daggerheart-firbolg-names",
      "url": "/pop-culture/daggerheart-firbolg-names"
    },
    {
      "name": "Fungril",
      "fullName": "Fungril",
      "slug": "daggerheart-fungril-names",
      "url": "/pop-culture/daggerheart-fungril-names"
    },
    {
      "name": "Galapa",
      "fullName": "Galapa",
      "slug": "daggerheart-galapa-names",
      "url": "/pop-culture/daggerheart-galapa-names"
    },
    {
      "name": "Halfling",
      "fullName": "Halfling",
      "slug": "daggerheart-halfling-names",
      "url": "/pop-culture/daggerheart-halfling-names"
    },
    {
      "name": "Human",
      "fullName": "Human",
      "slug": "daggerheart-human-names",
      "url": "/pop-culture/daggerheart-human-names"
    },
    {
      "name": "Infernis",
      "fullName": "Infernis",
      "slug": "daggerheart-infernis-names",
      "url": "/pop-culture/daggerheart-infernis-names"
    },
    {
      "name": "Katari",
      "fullName": "Katari",
      "slug": "daggerheart-katari-names",
      "url": "/pop-culture/daggerheart-katari-names"
    },
    {
      "name": "Ribbet",
      "fullName": "Ribbet",
      "slug": "daggerheart-ribbet-names",
      "url": "/pop-culture/daggerheart-ribbet-names"
    },
    {
      "name": "Simiah",
      "fullName": "Simiah",
      "slug": "daggerheart-simiah-names",
      "url": "/pop-culture/daggerheart-simiah-names"
    },
    {
      "name": "Daggerheart",
      "fullName": "Daggerheart",
      "slug": "daggerheart-names",
      "url": "/pop-culture/daggerheart-names"
    }
  ],
  "star-trek-vulcan-names": [
    {
      "name": "Andorian",
      "fullName": "Andorian",
      "slug": "star-trek-andorian-names",
      "url": "/pop-culture/star-trek-andorian-names"
    },
    {
      "name": "Bajoran",
      "fullName": "Bajoran",
      "slug": "star-trek-bajoran-names",
      "url": "/pop-culture/star-trek-bajoran-names"
    },
    {
      "name": "Benzite",
      "fullName": "Benzite",
      "slug": "star-trek-benzite-names",
      "url": "/pop-culture/star-trek-benzite-names"
    },
    {
      "name": "Betazoid",
      "fullName": "Betazoid",
      "slug": "star-trek-betazoid-names",
      "url": "/pop-culture/star-trek-betazoid-names"
    },
    {
      "name": "Bolian",
      "fullName": "Bolian",
      "slug": "star-trek-bolian-names",
      "url": "/pop-culture/star-trek-bolian-names"
    },
    {
      "name": "Caitian",
      "fullName": "Caitian",
      "slug": "star-trek-caitian-names",
      "url": "/pop-culture/star-trek-caitian-names"
    },
    {
      "name": "Cardassian",
      "fullName": "Cardassian",
      "slug": "star-trek-cardassian-names",
      "url": "/pop-culture/star-trek-cardassian-names"
    },
    {
      "name": "El-Aurian",
      "fullName": "El-Aurian",
      "slug": "star-trek-el-aurian-names",
      "url": "/pop-culture/star-trek-el-aurian-names"
    },
    {
      "name": "Ferengi",
      "fullName": "Ferengi",
      "slug": "star-trek-ferengi-names",
      "url": "/pop-culture/star-trek-ferengi-names"
    },
    {
      "name": "Gorn",
      "fullName": "Gorn",
      "slug": "star-trek-gorn-names",
      "url": "/pop-culture/star-trek-gorn-names"
    },
    {
      "name": "Hirogen",
      "fullName": "Hirogen",
      "slug": "star-trek-hirogen-names",
      "url": "/pop-culture/star-trek-hirogen-names"
    },
    {
      "name": "Jem'Hadar",
      "fullName": "Jem'Hadar",
      "slug": "star-trek-jemhadar-names",
      "url": "/pop-culture/star-trek-jemhadar-names"
    },
    {
      "name": "Kazon",
      "fullName": "Kazon",
      "slug": "star-trek-kazon-names",
      "url": "/pop-culture/star-trek-kazon-names"
    },
    {
      "name": "Klingon",
      "fullName": "Klingon",
      "slug": "star-trek-klingon-names",
      "url": "/pop-culture/star-trek-klingon-names"
    },
    {
      "name": "Lethean",
      "fullName": "Lethean",
      "slug": "star-trek-lethean-names",
      "url": "/pop-culture/star-trek-lethean-names"
    },
    {
      "name": "Nausicaan",
      "fullName": "Nausicaan",
      "slug": "star-trek-nausicaan-names",
      "url": "/pop-culture/star-trek-nausicaan-names"
    },
    {
      "name": "Orion",
      "fullName": "Orion",
      "slug": "star-trek-orion-names",
      "url": "/pop-culture/star-trek-orion-names"
    },
    {
      "name": "Pakled",
      "fullName": "Pakled",
      "slug": "star-trek-pakled-names",
      "url": "/pop-culture/star-trek-pakled-names"
    },
    {
      "name": "Reman",
      "fullName": "Reman",
      "slug": "star-trek-reman-names",
      "url": "/pop-culture/star-trek-reman-names"
    },
    {
      "name": "Rigelian",
      "fullName": "Rigelian",
      "slug": "star-trek-rigelian-names",
      "url": "/pop-culture/star-trek-rigelian-names"
    },
    {
      "name": "Romulan",
      "fullName": "Romulan",
      "slug": "star-trek-romulan-names",
      "url": "/pop-culture/star-trek-romulan-names"
    },
    {
      "name": "Saurian",
      "fullName": "Saurian",
      "slug": "star-trek-saurian-names",
      "url": "/pop-culture/star-trek-saurian-names"
    },
    {
      "name": "Suliban",
      "fullName": "Suliban",
      "slug": "star-trek-suliban-names",
      "url": "/pop-culture/star-trek-suliban-names"
    },
    {
      "name": "Tellarite",
      "fullName": "Tellarite",
      "slug": "star-trek-tellarite-names",
      "url": "/pop-culture/star-trek-tellarite-names"
    },
    {
      "name": "Trill",
      "fullName": "Trill",
      "slug": "star-trek-trill-names",
      "url": "/pop-culture/star-trek-trill-names"
    },
    {
      "name": "Vidiian",
      "fullName": "Vidiian",
      "slug": "star-trek-vidiian-names",
      "url": "/pop-culture/star-trek-vidiian-names"
    },
    {
      "name": "Vorta",
      "fullName": "Vorta",
      "slug": "star-trek-vorta-names",
      "url": "/pop-culture/star-trek-vorta-names"
    },
    {
      "name": "Vulcan",
      "fullName": "Vulcan",
      "slug": "star-trek-vulcan-names",
      "url": "/pop-culture/star-trek-vulcan-names"
    }
  ],
  "sw-mandalorian-names": [
    {
      "name": "Alderaanian",
      "fullName": "Alderaanian",
      "slug": "sw-alderaanian-names",
      "url": "/pop-culture/sw-alderaanian-names"
    },
    {
      "name": "Anzati",
      "fullName": "Anzati",
      "slug": "sw-anzati-names",
      "url": "/pop-culture/sw-anzati-names"
    },
    {
      "name": "Aqualish",
      "fullName": "Aqualish",
      "slug": "sw-aqualish-names",
      "url": "/pop-culture/sw-aqualish-names"
    },
    {
      "name": "Arkanian",
      "fullName": "Arkanian",
      "slug": "sw-arkanian-names",
      "url": "/pop-culture/sw-arkanian-names"
    },
    {
      "name": "Balosar",
      "fullName": "Balosar",
      "slug": "sw-balosar-names",
      "url": "/pop-culture/sw-balosar-names"
    },
    {
      "name": "Besalisk",
      "fullName": "Besalisk",
      "slug": "sw-besalisk-names",
      "url": "/pop-culture/sw-besalisk-names"
    },
    {
      "name": "Bith",
      "fullName": "Bith",
      "slug": "sw-bith-names",
      "url": "/pop-culture/sw-bith-names"
    },
    {
      "name": "Bothan",
      "fullName": "Bothan",
      "slug": "sw-bothan-names",
      "url": "/pop-culture/sw-bothan-names"
    },
    {
      "name": "Cerean",
      "fullName": "Cerean",
      "slug": "sw-cerean-names",
      "url": "/pop-culture/sw-cerean-names"
    },
    {
      "name": "Chalactan",
      "fullName": "Chalactan",
      "slug": "sw-chalactan-names",
      "url": "/pop-culture/sw-chalactan-names"
    },
    {
      "name": "Chandrilan",
      "fullName": "Chandrilan",
      "slug": "sw-chandrilan-names",
      "url": "/pop-culture/sw-chandrilan-names"
    },
    {
      "name": "Clawdite",
      "fullName": "Clawdite",
      "slug": "sw-clawdite-names",
      "url": "/pop-culture/sw-clawdite-names"
    },
    {
      "name": "Clone",
      "fullName": "Clone",
      "slug": "sw-clone-names",
      "url": "/pop-culture/sw-clone-names"
    },
    {
      "name": "Codru-Ji",
      "fullName": "Codru-Ji",
      "slug": "sw-codru-ji-names",
      "url": "/pop-culture/sw-codru-ji-names"
    },
    {
      "name": "Corellian",
      "fullName": "Corellian",
      "slug": "sw-corellian-names",
      "url": "/pop-culture/sw-corellian-names"
    },
    {
      "name": "Coruscanti",
      "fullName": "Coruscanti",
      "slug": "sw-coruscanti-names",
      "url": "/pop-culture/sw-coruscanti-names"
    },
    {
      "name": "Darth",
      "fullName": "Darth",
      "slug": "sw-darth-names",
      "url": "/pop-culture/sw-darth-names"
    },
    {
      "name": "Dathomirian",
      "fullName": "Dathomirian",
      "slug": "sw-dathomirian-names",
      "url": "/pop-culture/sw-dathomirian-names"
    },
    {
      "name": "Devaronian",
      "fullName": "Devaronian",
      "slug": "sw-devaronian-names",
      "url": "/pop-culture/sw-devaronian-names"
    },
    {
      "name": "Dug",
      "fullName": "Dug",
      "slug": "sw-dug-names",
      "url": "/pop-culture/sw-dug-names"
    },
    {
      "name": "Duros",
      "fullName": "Duros",
      "slug": "sw-duros-names",
      "url": "/pop-culture/sw-duros-names"
    },
    {
      "name": "Ewok",
      "fullName": "Ewok",
      "slug": "sw-ewok-names",
      "url": "/pop-culture/sw-ewok-names"
    },
    {
      "name": "Falleen",
      "fullName": "Falleen",
      "slug": "sw-falleen-names",
      "url": "/pop-culture/sw-falleen-names"
    },
    {
      "name": "Farghul",
      "fullName": "Farghul",
      "slug": "sw-farghul-names",
      "url": "/pop-culture/sw-farghul-names"
    },
    {
      "name": "Gamorrean",
      "fullName": "Gamorrean",
      "slug": "sw-gamorrean-names",
      "url": "/pop-culture/sw-gamorrean-names"
    },
    {
      "name": "Gand",
      "fullName": "Gand",
      "slug": "sw-gand-names",
      "url": "/pop-culture/sw-gand-names"
    },
    {
      "name": "Gen'dai",
      "fullName": "Gen'dai",
      "slug": "sw-gendai-names",
      "url": "/pop-culture/sw-gendai-names"
    },
    {
      "name": "Geonosian",
      "fullName": "Geonosian",
      "slug": "sw-geonosian-names",
      "url": "/pop-culture/sw-geonosian-names"
    },
    {
      "name": "Gotal",
      "fullName": "Gotal",
      "slug": "sw-gotal-names",
      "url": "/pop-culture/sw-gotal-names"
    },
    {
      "name": "Gran",
      "fullName": "Gran",
      "slug": "sw-gran-names",
      "url": "/pop-culture/sw-gran-names"
    },
    {
      "name": "Gungan",
      "fullName": "Gungan",
      "slug": "sw-gungan-names",
      "url": "/pop-culture/sw-gungan-names"
    },
    {
      "name": "Hutt",
      "fullName": "Hutt",
      "slug": "sw-hutt-names",
      "url": "/pop-culture/sw-hutt-names"
    },
    {
      "name": "Iktotchi",
      "fullName": "Iktotchi",
      "slug": "sw-iktotchi-names",
      "url": "/pop-culture/sw-iktotchi-names"
    },
    {
      "name": "Ishi Tib",
      "fullName": "Ishi Tib",
      "slug": "sw-ishi-tib-names",
      "url": "/pop-culture/sw-ishi-tib-names"
    },
    {
      "name": "Ithorian",
      "fullName": "Ithorian",
      "slug": "sw-ithorian-names",
      "url": "/pop-culture/sw-ithorian-names"
    },
    {
      "name": "Jawa",
      "fullName": "Jawa",
      "slug": "sw-jawa-names",
      "url": "/pop-culture/sw-jawa-names"
    },
    {
      "name": "Kaleesh",
      "fullName": "Kaleesh",
      "slug": "sw-kaleesh-names",
      "url": "/pop-culture/sw-kaleesh-names"
    },
    {
      "name": "Kaminoan",
      "fullName": "Kaminoan",
      "slug": "sw-kaminoan-names",
      "url": "/pop-culture/sw-kaminoan-names"
    },
    {
      "name": "Kel Dor",
      "fullName": "Kel Dor",
      "slug": "sw-kel-dor-names",
      "url": "/pop-culture/sw-kel-dor-names"
    },
    {
      "name": "Keshiri",
      "fullName": "Keshiri",
      "slug": "sw-keshiri-names",
      "url": "/pop-culture/sw-keshiri-names"
    },
    {
      "name": "Kiffar",
      "fullName": "Kiffar",
      "slug": "sw-kiffar-names",
      "url": "/pop-culture/sw-kiffar-names"
    },
    {
      "name": "Korunnai",
      "fullName": "Korunnai",
      "slug": "sw-korunnai-names",
      "url": "/pop-culture/sw-korunnai-names"
    },
    {
      "name": "Kowakian Monkey-Lizards",
      "fullName": "Kowakian Monkey-Lizards",
      "slug": "sw-kowakian-monkey-lizard-names",
      "url": "/pop-culture/sw-kowakian-monkey-lizard-names"
    },
    {
      "name": "Kubaz",
      "fullName": "Kubaz",
      "slug": "sw-kubaz-names",
      "url": "/pop-culture/sw-kubaz-names"
    },
    {
      "name": "Lasat",
      "fullName": "Lasat",
      "slug": "sw-lasat-names",
      "url": "/pop-culture/sw-lasat-names"
    },
    {
      "name": "Lightsaber Combat Forms",
      "fullName": "Lightsaber Combat Forms",
      "slug": "sw-lightsaber-combat-forms",
      "url": "/pop-culture/sw-lightsaber-combat-forms"
    },
    {
      "name": "Lothalite",
      "fullName": "Lothalite",
      "slug": "sw-lothalite-names",
      "url": "/pop-culture/sw-lothalite-names"
    },
    {
      "name": "Mandalorian",
      "fullName": "Mandalorian",
      "slug": "sw-mandalorian-names",
      "url": "/pop-culture/sw-mandalorian-names"
    },
    {
      "name": "Mikkian",
      "fullName": "Mikkian",
      "slug": "sw-mikkian-names",
      "url": "/pop-culture/sw-mikkian-names"
    },
    {
      "name": "Mirialan",
      "fullName": "Mirialan",
      "slug": "sw-mirialan-names",
      "url": "/pop-culture/sw-mirialan-names"
    },
    {
      "name": "Mon Calamari",
      "fullName": "Mon Calamari",
      "slug": "sw-mon-calamari-names",
      "url": "/pop-culture/sw-mon-calamari-names"
    },
    {
      "name": "Muun",
      "fullName": "Muun",
      "slug": "sw-muun-names",
      "url": "/pop-culture/sw-muun-names"
    },
    {
      "name": "Nautolan",
      "fullName": "Nautolan",
      "slug": "sw-nautolan-names",
      "url": "/pop-culture/sw-nautolan-names"
    },
    {
      "name": "Naboo",
      "fullName": "Naboo",
      "slug": "sw-naboo-names",
      "url": "/pop-culture/sw-naboo-names"
    },
    {
      "name": "Neimoidian",
      "fullName": "Neimoidian",
      "slug": "sw-neimoidian-names",
      "url": "/pop-culture/sw-neimoidian-names"
    },
    {
      "name": "Nikto",
      "fullName": "Nikto",
      "slug": "sw-nikto-names",
      "url": "/pop-culture/sw-nikto-names"
    },
    {
      "name": "Nothoiin",
      "fullName": "Nothoiin",
      "slug": "sw-nothoiin-names",
      "url": "/pop-culture/sw-nothoiin-names"
    },
    {
      "name": "Onderonian",
      "fullName": "Onderonian",
      "slug": "sw-onderonian-names",
      "url": "/pop-culture/sw-onderonian-names"
    },
    {
      "name": "Ortolan",
      "fullName": "Ortolan",
      "slug": "sw-ortolan-names",
      "url": "/pop-culture/sw-ortolan-names"
    },
    {
      "name": "Pantoran",
      "fullName": "Pantoran",
      "slug": "sw-pantoran-names",
      "url": "/pop-culture/sw-pantoran-names"
    },
    {
      "name": "Pau'an",
      "fullName": "Pau'an",
      "slug": "sw-pauan-names",
      "url": "/pop-culture/sw-pauan-names"
    },
    {
      "name": "Quarren",
      "fullName": "Quarren",
      "slug": "sw-quarren-names",
      "url": "/pop-culture/sw-quarren-names"
    },
    {
      "name": "Rodian",
      "fullName": "Rodian",
      "slug": "sw-rodian-names",
      "url": "/pop-culture/sw-rodian-names"
    },
    {
      "name": "Savarian",
      "fullName": "Savarian",
      "slug": "sw-savarian-names",
      "url": "/pop-culture/sw-savarian-names"
    },
    {
      "name": "Selkath",
      "fullName": "Selkath",
      "slug": "sw-selkath-names",
      "url": "/pop-culture/sw-selkath-names"
    },
    {
      "name": "Selonian",
      "fullName": "Selonian",
      "slug": "sw-selonian-names",
      "url": "/pop-culture/sw-selonian-names"
    },
    {
      "name": "Sephi",
      "fullName": "Sephi",
      "slug": "sw-sephi-names",
      "url": "/pop-culture/sw-sephi-names"
    },
    {
      "name": "Serennian",
      "fullName": "Serennian",
      "slug": "sw-serennian-names",
      "url": "/pop-culture/sw-serennian-names"
    },
    {
      "name": "Shistavanen",
      "fullName": "Shistavanen",
      "slug": "sw-shistavanen-names",
      "url": "/pop-culture/sw-shistavanen-names"
    },
    {
      "name": "Skakoan",
      "fullName": "Skakoan",
      "slug": "sw-skakoan-names",
      "url": "/pop-culture/sw-skakoan-names"
    },
    {
      "name": "Snivvian",
      "fullName": "Snivvian",
      "slug": "sw-snivvian-names",
      "url": "/pop-culture/sw-snivvian-names"
    },
    {
      "name": "Spaceship",
      "fullName": "Spaceship",
      "slug": "sw-spaceship-names",
      "url": "/pop-culture/sw-spaceship-names"
    },
    {
      "name": "Stormtrooper",
      "fullName": "Stormtrooper",
      "slug": "sw-stormtrooper-names",
      "url": "/pop-culture/sw-stormtrooper-names"
    },
    {
      "name": "Sullustan",
      "fullName": "Sullustan",
      "slug": "sw-sullustan-names",
      "url": "/pop-culture/sw-sullustan-names"
    },
    {
      "name": "Talz",
      "fullName": "Talz",
      "slug": "sw-talz-names",
      "url": "/pop-culture/sw-talz-names"
    },
    {
      "name": "Tholothian",
      "fullName": "Tholothian",
      "slug": "sw-tholothian-names",
      "url": "/pop-culture/sw-tholothian-names"
    },
    {
      "name": "Togruta",
      "fullName": "Togruta",
      "slug": "sw-togruta-names",
      "url": "/pop-culture/sw-togruta-names"
    },
    {
      "name": "Trandoshan",
      "fullName": "Trandoshan",
      "slug": "sw-trandoshan-names",
      "url": "/pop-culture/sw-trandoshan-names"
    },
    {
      "name": "Tusken",
      "fullName": "Tusken",
      "slug": "sw-tusken-raider-names",
      "url": "/pop-culture/sw-tusken-raider-names"
    },
    {
      "name": "Twi'lek",
      "fullName": "Twi'lek",
      "slug": "sw-twilek-names",
      "url": "/pop-culture/sw-twilek-names"
    },
    {
      "name": "Weequay",
      "fullName": "Weequay",
      "slug": "sw-weequay-names",
      "url": "/pop-culture/sw-weequay-names"
    },
    {
      "name": "Wookiee",
      "fullName": "Wookiee",
      "slug": "sw-wookiee-names",
      "url": "/pop-culture/sw-wookiee-names"
    },
    {
      "name": "Yarkora",
      "fullName": "Yarkora",
      "slug": "sw-yarkora-names",
      "url": "/pop-culture/sw-yarkora-names"
    },
    {
      "name": "Zabrak",
      "fullName": "Zabrak",
      "slug": "sw-zabrak-names",
      "url": "/pop-culture/sw-zabrak-names"
    },
    {
      "name": "Zeltron",
      "fullName": "Zeltron",
      "slug": "sw-zeltron-names",
      "url": "/pop-culture/sw-zeltron-names"
    },
    {
      "name": "Zygerrian",
      "fullName": "Zygerrian",
      "slug": "sw-zygerrian-names",
      "url": "/pop-culture/sw-zygerrian-names"
    },
    {
      "name": "Chiss",
      "fullName": "Chiss",
      "slug": "chiss-names",
      "url": "/other-names/chiss-names"
    },
    {
      "name": "Sith Pureblood",
      "fullName": "Sith Pureblood",
      "slug": "sith-names",
      "url": "/other-names/sith-names"
    },
    {
      "name": "Zabrak",
      "fullName": "Zabrak",
      "slug": "sw-zabrak-names",
      "url": "/pop-culture/sw-zabrak-names"
    },
    {
      "name": "Planet",
      "fullName": "Planet",
      "slug": "sw-planet-names",
      "url": "/pop-culture/sw-planet-names"
    },
    {
      "name": "Toydarian",
      "fullName": "Toydarian",
      "slug": "sw-toydarian-names",
      "url": "/pop-culture/sw-toydarian-names"
    }
  ],
  "sw-planet-names": [
    {
      "name": "Alderaanian",
      "fullName": "Alderaanian",
      "slug": "sw-alderaanian-names",
      "url": "/pop-culture/sw-alderaanian-names"
    },
    {
      "name": "Anzati",
      "fullName": "Anzati",
      "slug": "sw-anzati-names",
      "url": "/pop-culture/sw-anzati-names"
    },
    {
      "name": "Aqualish",
      "fullName": "Aqualish",
      "slug": "sw-aqualish-names",
      "url": "/pop-culture/sw-aqualish-names"
    },
    {
      "name": "Arkanian",
      "fullName": "Arkanian",
      "slug": "sw-arkanian-names",
      "url": "/pop-culture/sw-arkanian-names"
    },
    {
      "name": "Balosar",
      "fullName": "Balosar",
      "slug": "sw-balosar-names",
      "url": "/pop-culture/sw-balosar-names"
    },
    {
      "name": "Besalisk",
      "fullName": "Besalisk",
      "slug": "sw-besalisk-names",
      "url": "/pop-culture/sw-besalisk-names"
    },
    {
      "name": "Bith",
      "fullName": "Bith",
      "slug": "sw-bith-names",
      "url": "/pop-culture/sw-bith-names"
    },
    {
      "name": "Bothan",
      "fullName": "Bothan",
      "slug": "sw-bothan-names",
      "url": "/pop-culture/sw-bothan-names"
    },
    {
      "name": "Cerean",
      "fullName": "Cerean",
      "slug": "sw-cerean-names",
      "url": "/pop-culture/sw-cerean-names"
    },
    {
      "name": "Chalactan",
      "fullName": "Chalactan",
      "slug": "sw-chalactan-names",
      "url": "/pop-culture/sw-chalactan-names"
    },
    {
      "name": "Chandrilan",
      "fullName": "Chandrilan",
      "slug": "sw-chandrilan-names",
      "url": "/pop-culture/sw-chandrilan-names"
    },
    {
      "name": "Clawdite",
      "fullName": "Clawdite",
      "slug": "sw-clawdite-names",
      "url": "/pop-culture/sw-clawdite-names"
    },
    {
      "name": "Clone",
      "fullName": "Clone",
      "slug": "sw-clone-names",
      "url": "/pop-culture/sw-clone-names"
    },
    {
      "name": "Codru-Ji",
      "fullName": "Codru-Ji",
      "slug": "sw-codru-ji-names",
      "url": "/pop-culture/sw-codru-ji-names"
    },
    {
      "name": "Corellian",
      "fullName": "Corellian",
      "slug": "sw-corellian-names",
      "url": "/pop-culture/sw-corellian-names"
    },
    {
      "name": "Coruscanti",
      "fullName": "Coruscanti",
      "slug": "sw-coruscanti-names",
      "url": "/pop-culture/sw-coruscanti-names"
    },
    {
      "name": "Darth",
      "fullName": "Darth",
      "slug": "sw-darth-names",
      "url": "/pop-culture/sw-darth-names"
    },
    {
      "name": "Dathomirian",
      "fullName": "Dathomirian",
      "slug": "sw-dathomirian-names",
      "url": "/pop-culture/sw-dathomirian-names"
    },
    {
      "name": "Devaronian",
      "fullName": "Devaronian",
      "slug": "sw-devaronian-names",
      "url": "/pop-culture/sw-devaronian-names"
    },
    {
      "name": "Dug",
      "fullName": "Dug",
      "slug": "sw-dug-names",
      "url": "/pop-culture/sw-dug-names"
    },
    {
      "name": "Duros",
      "fullName": "Duros",
      "slug": "sw-duros-names",
      "url": "/pop-culture/sw-duros-names"
    },
    {
      "name": "Ewok",
      "fullName": "Ewok",
      "slug": "sw-ewok-names",
      "url": "/pop-culture/sw-ewok-names"
    },
    {
      "name": "Falleen",
      "fullName": "Falleen",
      "slug": "sw-falleen-names",
      "url": "/pop-culture/sw-falleen-names"
    },
    {
      "name": "Farghul",
      "fullName": "Farghul",
      "slug": "sw-farghul-names",
      "url": "/pop-culture/sw-farghul-names"
    },
    {
      "name": "Gamorrean",
      "fullName": "Gamorrean",
      "slug": "sw-gamorrean-names",
      "url": "/pop-culture/sw-gamorrean-names"
    },
    {
      "name": "Gand",
      "fullName": "Gand",
      "slug": "sw-gand-names",
      "url": "/pop-culture/sw-gand-names"
    },
    {
      "name": "Gen'dai",
      "fullName": "Gen'dai",
      "slug": "sw-gendai-names",
      "url": "/pop-culture/sw-gendai-names"
    },
    {
      "name": "Geonosian",
      "fullName": "Geonosian",
      "slug": "sw-geonosian-names",
      "url": "/pop-culture/sw-geonosian-names"
    },
    {
      "name": "Gotal",
      "fullName": "Gotal",
      "slug": "sw-gotal-names",
      "url": "/pop-culture/sw-gotal-names"
    },
    {
      "name": "Gran",
      "fullName": "Gran",
      "slug": "sw-gran-names",
      "url": "/pop-culture/sw-gran-names"
    },
    {
      "name": "Gungan",
      "fullName": "Gungan",
      "slug": "sw-gungan-names",
      "url": "/pop-culture/sw-gungan-names"
    },
    {
      "name": "Hutt",
      "fullName": "Hutt",
      "slug": "sw-hutt-names",
      "url": "/pop-culture/sw-hutt-names"
    },
    {
      "name": "Iktotchi",
      "fullName": "Iktotchi",
      "slug": "sw-iktotchi-names",
      "url": "/pop-culture/sw-iktotchi-names"
    },
    {
      "name": "Ishi Tib",
      "fullName": "Ishi Tib",
      "slug": "sw-ishi-tib-names",
      "url": "/pop-culture/sw-ishi-tib-names"
    },
    {
      "name": "Ithorian",
      "fullName": "Ithorian",
      "slug": "sw-ithorian-names",
      "url": "/pop-culture/sw-ithorian-names"
    },
    {
      "name": "Jawa",
      "fullName": "Jawa",
      "slug": "sw-jawa-names",
      "url": "/pop-culture/sw-jawa-names"
    },
    {
      "name": "Kaleesh",
      "fullName": "Kaleesh",
      "slug": "sw-kaleesh-names",
      "url": "/pop-culture/sw-kaleesh-names"
    },
    {
      "name": "Kaminoan",
      "fullName": "Kaminoan",
      "slug": "sw-kaminoan-names",
      "url": "/pop-culture/sw-kaminoan-names"
    },
    {
      "name": "Kel Dor",
      "fullName": "Kel Dor",
      "slug": "sw-kel-dor-names",
      "url": "/pop-culture/sw-kel-dor-names"
    },
    {
      "name": "Keshiri",
      "fullName": "Keshiri",
      "slug": "sw-keshiri-names",
      "url": "/pop-culture/sw-keshiri-names"
    },
    {
      "name": "Kiffar",
      "fullName": "Kiffar",
      "slug": "sw-kiffar-names",
      "url": "/pop-culture/sw-kiffar-names"
    },
    {
      "name": "Korunnai",
      "fullName": "Korunnai",
      "slug": "sw-korunnai-names",
      "url": "/pop-culture/sw-korunnai-names"
    },
    {
      "name": "Kowakian Monkey-Lizards",
      "fullName": "Kowakian Monkey-Lizards",
      "slug": "sw-kowakian-monkey-lizard-names",
      "url": "/pop-culture/sw-kowakian-monkey-lizard-names"
    },
    {
      "name": "Kubaz",
      "fullName": "Kubaz",
      "slug": "sw-kubaz-names",
      "url": "/pop-culture/sw-kubaz-names"
    },
    {
      "name": "Lasat",
      "fullName": "Lasat",
      "slug": "sw-lasat-names",
      "url": "/pop-culture/sw-lasat-names"
    },
    {
      "name": "Lightsaber Combat Forms",
      "fullName": "Lightsaber Combat Forms",
      "slug": "sw-lightsaber-combat-forms",
      "url": "/pop-culture/sw-lightsaber-combat-forms"
    },
    {
      "name": "Lothalite",
      "fullName": "Lothalite",
      "slug": "sw-lothalite-names",
      "url": "/pop-culture/sw-lothalite-names"
    },
    {
      "name": "Mandalorian",
      "fullName": "Mandalorian",
      "slug": "sw-mandalorian-names",
      "url": "/pop-culture/sw-mandalorian-names"
    },
    {
      "name": "Mikkian",
      "fullName": "Mikkian",
      "slug": "sw-mikkian-names",
      "url": "/pop-culture/sw-mikkian-names"
    },
    {
      "name": "Mirialan",
      "fullName": "Mirialan",
      "slug": "sw-mirialan-names",
      "url": "/pop-culture/sw-mirialan-names"
    },
    {
      "name": "Mon Calamari",
      "fullName": "Mon Calamari",
      "slug": "sw-mon-calamari-names",
      "url": "/pop-culture/sw-mon-calamari-names"
    },
    {
      "name": "Muun",
      "fullName": "Muun",
      "slug": "sw-muun-names",
      "url": "/pop-culture/sw-muun-names"
    },
    {
      "name": "Nautolan",
      "fullName": "Nautolan",
      "slug": "sw-nautolan-names",
      "url": "/pop-culture/sw-nautolan-names"
    },
    {
      "name": "Naboo",
      "fullName": "Naboo",
      "slug": "sw-naboo-names",
      "url": "/pop-culture/sw-naboo-names"
    },
    {
      "name": "Neimoidian",
      "fullName": "Neimoidian",
      "slug": "sw-neimoidian-names",
      "url": "/pop-culture/sw-neimoidian-names"
    },
    {
      "name": "Nikto",
      "fullName": "Nikto",
      "slug": "sw-nikto-names",
      "url": "/pop-culture/sw-nikto-names"
    },
    {
      "name": "Nothoiin",
      "fullName": "Nothoiin",
      "slug": "sw-nothoiin-names",
      "url": "/pop-culture/sw-nothoiin-names"
    },
    {
      "name": "Onderonian",
      "fullName": "Onderonian",
      "slug": "sw-onderonian-names",
      "url": "/pop-culture/sw-onderonian-names"
    },
    {
      "name": "Ortolan",
      "fullName": "Ortolan",
      "slug": "sw-ortolan-names",
      "url": "/pop-culture/sw-ortolan-names"
    },
    {
      "name": "Pantoran",
      "fullName": "Pantoran",
      "slug": "sw-pantoran-names",
      "url": "/pop-culture/sw-pantoran-names"
    },
    {
      "name": "Pau'an",
      "fullName": "Pau'an",
      "slug": "sw-pauan-names",
      "url": "/pop-culture/sw-pauan-names"
    },
    {
      "name": "Quarren",
      "fullName": "Quarren",
      "slug": "sw-quarren-names",
      "url": "/pop-culture/sw-quarren-names"
    },
    {
      "name": "Rodian",
      "fullName": "Rodian",
      "slug": "sw-rodian-names",
      "url": "/pop-culture/sw-rodian-names"
    },
    {
      "name": "Savarian",
      "fullName": "Savarian",
      "slug": "sw-savarian-names",
      "url": "/pop-culture/sw-savarian-names"
    },
    {
      "name": "Selkath",
      "fullName": "Selkath",
      "slug": "sw-selkath-names",
      "url": "/pop-culture/sw-selkath-names"
    },
    {
      "name": "Selonian",
      "fullName": "Selonian",
      "slug": "sw-selonian-names",
      "url": "/pop-culture/sw-selonian-names"
    },
    {
      "name": "Sephi",
      "fullName": "Sephi",
      "slug": "sw-sephi-names",
      "url": "/pop-culture/sw-sephi-names"
    },
    {
      "name": "Serennian",
      "fullName": "Serennian",
      "slug": "sw-serennian-names",
      "url": "/pop-culture/sw-serennian-names"
    },
    {
      "name": "Shistavanen",
      "fullName": "Shistavanen",
      "slug": "sw-shistavanen-names",
      "url": "/pop-culture/sw-shistavanen-names"
    },
    {
      "name": "Skakoan",
      "fullName": "Skakoan",
      "slug": "sw-skakoan-names",
      "url": "/pop-culture/sw-skakoan-names"
    },
    {
      "name": "Snivvian",
      "fullName": "Snivvian",
      "slug": "sw-snivvian-names",
      "url": "/pop-culture/sw-snivvian-names"
    },
    {
      "name": "Spaceship",
      "fullName": "Spaceship",
      "slug": "sw-spaceship-names",
      "url": "/pop-culture/sw-spaceship-names"
    },
    {
      "name": "Stormtrooper",
      "fullName": "Stormtrooper",
      "slug": "sw-stormtrooper-names",
      "url": "/pop-culture/sw-stormtrooper-names"
    },
    {
      "name": "Sullustan",
      "fullName": "Sullustan",
      "slug": "sw-sullustan-names",
      "url": "/pop-culture/sw-sullustan-names"
    },
    {
      "name": "Talz",
      "fullName": "Talz",
      "slug": "sw-talz-names",
      "url": "/pop-culture/sw-talz-names"
    },
    {
      "name": "Tholothian",
      "fullName": "Tholothian",
      "slug": "sw-tholothian-names",
      "url": "/pop-culture/sw-tholothian-names"
    },
    {
      "name": "Togruta",
      "fullName": "Togruta",
      "slug": "sw-togruta-names",
      "url": "/pop-culture/sw-togruta-names"
    },
    {
      "name": "Trandoshan",
      "fullName": "Trandoshan",
      "slug": "sw-trandoshan-names",
      "url": "/pop-culture/sw-trandoshan-names"
    },
    {
      "name": "Tusken",
      "fullName": "Tusken",
      "slug": "sw-tusken-raider-names",
      "url": "/pop-culture/sw-tusken-raider-names"
    },
    {
      "name": "Twi'lek",
      "fullName": "Twi'lek",
      "slug": "sw-twilek-names",
      "url": "/pop-culture/sw-twilek-names"
    },
    {
      "name": "Weequay",
      "fullName": "Weequay",
      "slug": "sw-weequay-names",
      "url": "/pop-culture/sw-weequay-names"
    },
    {
      "name": "Wookiee",
      "fullName": "Wookiee",
      "slug": "sw-wookiee-names",
      "url": "/pop-culture/sw-wookiee-names"
    },
    {
      "name": "Yarkora",
      "fullName": "Yarkora",
      "slug": "sw-yarkora-names",
      "url": "/pop-culture/sw-yarkora-names"
    },
    {
      "name": "Zabrak",
      "fullName": "Zabrak",
      "slug": "sw-zabrak-names",
      "url": "/pop-culture/sw-zabrak-names"
    },
    {
      "name": "Zeltron",
      "fullName": "Zeltron",
      "slug": "sw-zeltron-names",
      "url": "/pop-culture/sw-zeltron-names"
    },
    {
      "name": "Zygerrian",
      "fullName": "Zygerrian",
      "slug": "sw-zygerrian-names",
      "url": "/pop-culture/sw-zygerrian-names"
    },
    {
      "name": "Planet",
      "fullName": "Planet",
      "slug": "sw-planet-names",
      "url": "/pop-culture/sw-planet-names"
    },
    {
      "name": "Toydarian",
      "fullName": "Toydarian",
      "slug": "sw-toydarian-names",
      "url": "/pop-culture/sw-toydarian-names"
    }
  ],
  "wow-ankoan-names": [
    {
      "name": "Ankoan",
      "fullName": "Ankoan",
      "slug": "wow-ankoan-names",
      "url": "/pop-culture/wow-ankoan-names"
    },
    {
      "name": "Annihilan",
      "fullName": "Annihilan",
      "slug": "wow-annihilan-names",
      "url": "/pop-culture/wow-annihilan-names"
    },
    {
      "name": "Anubisath",
      "fullName": "Anubisath",
      "slug": "wow-anubisath-names",
      "url": "/pop-culture/wow-anubisath-names"
    },
    {
      "name": "Arakkoa",
      "fullName": "Arakkoa",
      "slug": "wow-arakkoa-names",
      "url": "/pop-culture/wow-arakkoa-names"
    },
    {
      "name": "Aranakk",
      "fullName": "Aranakk",
      "slug": "wow-aranakk-names",
      "url": "/pop-culture/wow-aranakk-names"
    },
    {
      "name": "Aranasi",
      "fullName": "Aranasi",
      "slug": "wow-aranasi-names",
      "url": "/pop-culture/wow-aranasi-names"
    },
    {
      "name": "Botani",
      "fullName": "Botani",
      "slug": "wow-botani-names",
      "url": "/pop-culture/wow-botani-names"
    },
    {
      "name": "Broker",
      "fullName": "Broker",
      "slug": "wow-broker-names",
      "url": "/pop-culture/wow-broker-names"
    },
    {
      "name": "Centaur",
      "fullName": "Centaur",
      "slug": "wow-centaur-names",
      "url": "/pop-culture/wow-centaur-names"
    },
    {
      "name": "Constellar",
      "fullName": "Constellar",
      "slug": "wow-constellar-names",
      "url": "/pop-culture/wow-constellar-names"
    },
    {
      "name": "Djaradin",
      "fullName": "Djaradin",
      "slug": "wow-djaradin-names",
      "url": "/pop-culture/wow-djaradin-names"
    },
    {
      "name": "Doomguard",
      "fullName": "Doomguard",
      "slug": "wow-doomguard-names",
      "url": "/pop-culture/wow-doomguard-names"
    },
    {
      "name": "Dragon (Black)",
      "fullName": "Dragon (Black)",
      "slug": "wow-black-dragon-names",
      "url": "/pop-culture/wow-black-dragon-names"
    },
    {
      "name": "Dragon (Blue)",
      "fullName": "Dragon (Blue)",
      "slug": "wow-blue-dragon-names",
      "url": "/pop-culture/wow-blue-dragon-names"
    },
    {
      "name": "Dragon (Bronze)",
      "fullName": "Dragon (Bronze)",
      "slug": "wow-bronze-dragon-names",
      "url": "/pop-culture/wow-bronze-dragon-names"
    },
    {
      "name": "Dragon (Green)",
      "fullName": "Dragon (Green)",
      "slug": "wow-green-dragon-names",
      "url": "/pop-culture/wow-green-dragon-names"
    },
    {
      "name": "Dragon (Red)",
      "fullName": "Dragon (Red)",
      "slug": "wow-red-dragon-names",
      "url": "/pop-culture/wow-red-dragon-names"
    },
    {
      "name": "Drogbar",
      "fullName": "Drogbar",
      "slug": "wow-drogbar-names",
      "url": "/pop-culture/wow-drogbar-names"
    },
    {
      "name": "Dryad",
      "fullName": "Dryad",
      "slug": "wow-dryad-names",
      "url": "/pop-culture/wow-dryad-names"
    },
    {
      "name": "Ethereal",
      "fullName": "Ethereal",
      "slug": "wow-ethereal-names",
      "url": "/pop-culture/wow-ethereal-names"
    },
    {
      "name": "Faerie",
      "fullName": "Faerie",
      "slug": "wow-faerie-names",
      "url": "/pop-culture/wow-faerie-names"
    },
    {
      "name": "Flamewaker",
      "fullName": "Flamewaker",
      "slug": "wow-flamewaker-names",
      "url": "/pop-culture/wow-flamewaker-names"
    },
    {
      "name": "Frost Giant",
      "fullName": "Frost Giant",
      "slug": "wow-frost-giant-names",
      "url": "/pop-culture/wow-frost-giant-names"
    },
    {
      "name": "Furbolg",
      "fullName": "Furbolg",
      "slug": "wow-furbolg-names",
      "url": "/pop-culture/wow-furbolg-names"
    },
    {
      "name": "Gnoll",
      "fullName": "Gnoll",
      "slug": "wow-gnoll-names",
      "url": "/pop-culture/wow-gnoll-names"
    },
    {
      "name": "Goren",
      "fullName": "Goren",
      "slug": "wow-goren-names",
      "url": "/pop-culture/wow-goren-names"
    },
    {
      "name": "Gryphon",
      "fullName": "Gryphon",
      "slug": "wow-gryphon-names",
      "url": "/pop-culture/wow-gryphon-names"
    },
    {
      "name": "Grummle",
      "fullName": "Grummle",
      "slug": "wow-grummle-names",
      "url": "/pop-culture/wow-grummle-names"
    },
    {
      "name": "Harpy",
      "fullName": "Harpy",
      "slug": "wow-harpy-names",
      "url": "/pop-culture/wow-harpy-names"
    },
    {
      "name": "Hippogryph",
      "fullName": "Hippogryph",
      "slug": "wow-hippogryph-names",
      "url": "/pop-culture/wow-hippogryph-names"
    },
    {
      "name": "Hozen",
      "fullName": "Hozen",
      "slug": "wow-hozen-names",
      "url": "/pop-culture/wow-hozen-names"
    },
    {
      "name": "Inquisitor",
      "fullName": "Inquisitor",
      "slug": "wow-inquisitor-names",
      "url": "/pop-culture/wow-inquisitor-names"
    },
    {
      "name": "Jinyu",
      "fullName": "Jinyu",
      "slug": "wow-jinyu-names",
      "url": "/pop-culture/wow-jinyu-names"
    },
    {
      "name": "Kobold",
      "fullName": "Kobold",
      "slug": "wow-kobold-names",
      "url": "/pop-culture/wow-kobold-names"
    },
    {
      "name": "Kyrian",
      "fullName": "Kyrian",
      "slug": "wow-kyrian-names",
      "url": "/pop-culture/wow-kyrian-names"
    },
    {
      "name": "K'thir",
      "fullName": "K'thir",
      "slug": "wow-kthir-names",
      "url": "/pop-culture/wow-kthir-names"
    },
    {
      "name": "Man'ari Eredar",
      "fullName": "Man'ari Eredar",
      "slug": "wow-manari-eredar-names",
      "url": "/pop-culture/wow-manari-eredar-names"
    },
    {
      "name": "Mantid",
      "fullName": "Mantid",
      "slug": "wow-mantid-names",
      "url": "/pop-culture/wow-mantid-names"
    },
    {
      "name": "Mo'arg",
      "fullName": "Mo'arg",
      "slug": "wow-moarg-names",
      "url": "/pop-culture/wow-moarg-names"
    },
    {
      "name": "Mogu",
      "fullName": "Mogu",
      "slug": "wow-mogu-names",
      "url": "/pop-culture/wow-mogu-names"
    },
    {
      "name": "Murloc",
      "fullName": "Murloc",
      "slug": "wow-murloc-names",
      "url": "/pop-culture/wow-murloc-names"
    },
    {
      "name": "Naaru",
      "fullName": "Naaru",
      "slug": "wow-naaru-names",
      "url": "/pop-culture/wow-naaru-names"
    },
    {
      "name": "Naga",
      "fullName": "Naga",
      "slug": "wow-naga-names",
      "url": "/pop-culture/wow-naga-names"
    },
    {
      "name": "Nathrezim",
      "fullName": "Nathrezim",
      "slug": "wow-nathrezim-names",
      "url": "/pop-culture/wow-nathrezim-names"
    },
    {
      "name": "Necrolord",
      "fullName": "Necrolord",
      "slug": "wow-necrolord-names",
      "url": "/pop-culture/wow-necrolord-names"
    },
    {
      "name": "Nerubian",
      "fullName": "Nerubian",
      "slug": "wow-nerubian-names",
      "url": "/pop-culture/wow-nerubian-names"
    },
    {
      "name": "N'raqi",
      "fullName": "N'raqi",
      "slug": "wow-nraqi-names",
      "url": "/pop-culture/wow-nraqi-names"
    },
    {
      "name": "Observer",
      "fullName": "Observer",
      "slug": "wow-observer-names",
      "url": "/pop-culture/wow-observer-names"
    },
    {
      "name": "Ogre",
      "fullName": "Ogre",
      "slug": "wow-ogre-names",
      "url": "/pop-culture/wow-ogre-names"
    },
    {
      "name": "Qiraji",
      "fullName": "Qiraji",
      "slug": "wow-qiraji-names",
      "url": "/pop-culture/wow-qiraji-names"
    },
    {
      "name": "Quilboar",
      "fullName": "Quilboar",
      "slug": "wow-quilboar-names",
      "url": "/pop-culture/wow-quilboar-names"
    },
    {
      "name": "Saberon",
      "fullName": "Saberon",
      "slug": "wow-saberon-names",
      "url": "/pop-culture/wow-saberon-names"
    },
    {
      "name": "Satyr",
      "fullName": "Satyr",
      "slug": "wow-satyr-names",
      "url": "/pop-culture/wow-satyr-names"
    },
    {
      "name": "Saurok",
      "fullName": "Saurok",
      "slug": "wow-saurok-names",
      "url": "/pop-culture/wow-saurok-names"
    },
    {
      "name": "Sayaadi",
      "fullName": "Sayaadi",
      "slug": "wow-sayaadi-names",
      "url": "/pop-culture/wow-sayaadi-names"
    },
    {
      "name": "Sea Giant",
      "fullName": "Sea Giant",
      "slug": "wow-sea-giant-names",
      "url": "/pop-culture/wow-sea-giant-names"
    },
    {
      "name": "Sethrak",
      "fullName": "Sethrak",
      "slug": "wow-sethrak-names",
      "url": "/pop-culture/wow-sethrak-names"
    },
    {
      "name": "Shivarra",
      "fullName": "Shivarra",
      "slug": "wow-shivarra-names",
      "url": "/pop-culture/wow-shivarra-names"
    },
    {
      "name": "Silithid",
      "fullName": "Silithid",
      "slug": "wow-silithid-names",
      "url": "/pop-culture/wow-silithid-names"
    },
    {
      "name": "Sylvar",
      "fullName": "Sylvar",
      "slug": "wow-sylvar-names",
      "url": "/pop-culture/wow-sylvar-names"
    },
    {
      "name": "Taunka",
      "fullName": "Taunka",
      "slug": "wow-taunka-names",
      "url": "/pop-culture/wow-taunka-names"
    },
    {
      "name": "Titan",
      "fullName": "Titan",
      "slug": "wow-titan-names",
      "url": "/pop-culture/wow-titan-names"
    },
    {
      "name": "Tol'Vir",
      "fullName": "Tol'Vir",
      "slug": "wow-tolvir-names",
      "url": "/pop-culture/wow-tolvir-names"
    },
    {
      "name": "Tortollan",
      "fullName": "Tortollan",
      "slug": "wow-tortollan-names",
      "url": "/pop-culture/wow-tortollan-names"
    },
    {
      "name": "Trogg",
      "fullName": "Trogg",
      "slug": "wow-trogg-names",
      "url": "/pop-culture/wow-trogg-names"
    },
    {
      "name": "Tuskarr",
      "fullName": "Tuskarr",
      "slug": "wow-tuskarr-names",
      "url": "/pop-culture/wow-tuskarr-names"
    },
    {
      "name": "Venthyr",
      "fullName": "Venthyr",
      "slug": "wow-venthyr-names",
      "url": "/pop-culture/wow-venthyr-names"
    },
    {
      "name": "Voidwalker",
      "fullName": "Voidwalker",
      "slug": "wow-voidwalker-names",
      "url": "/pop-culture/wow-voidwalker-names"
    },
    {
      "name": "Vrykul",
      "fullName": "Vrykul",
      "slug": "wow-vrykul-names",
      "url": "/pop-culture/wow-vrykul-names"
    },
    {
      "name": "Wyrmtongue",
      "fullName": "Wyrmtongue",
      "slug": "wow-wyrmtongue-names",
      "url": "/pop-culture/wow-wyrmtongue-names"
    },
    {
      "name": "Misc.",
      "fullName": "WoW Misc.",
      "slug": "wow-pet-names",
      "url": "/pop-culture/wow-pet-names"
    },
    {
      "name": "Dark Iron Dwarf",
      "fullName": "Dark Iron Dwarf",
      "slug": "wow-dark-iron-dwarf-names",
      "url": "/pop-culture/wow-dark-iron-dwarf-names"
    },
    {
      "name": "Haranir",
      "fullName": "Haranir",
      "slug": "wow-haranir-names",
      "url": "/pop-culture/wow-haranir-names"
    },
    {
      "name": "Highmountain Tauren",
      "fullName": "Highmountain Tauren",
      "slug": "wow-highmountain-tauren-names",
      "url": "/pop-culture/wow-highmountain-tauren-names"
    },
    {
      "name": "Lightforged Draenei",
      "fullName": "Lightforged Draenei",
      "slug": "wow-lightforged-draenei-names",
      "url": "/pop-culture/wow-lightforged-draenei-names"
    },
    {
      "name": "Mechagnome",
      "fullName": "Mechagnome",
      "slug": "wow-mechagnome-names",
      "url": "/pop-culture/wow-mechagnome-names"
    },
    {
      "name": "Nightborne",
      "fullName": "Nightborne",
      "slug": "wow-nightborne-names",
      "url": "/pop-culture/wow-nightborne-names"
    },
    {
      "name": "Void Elf",
      "fullName": "Void Elf",
      "slug": "wow-void-elf-names",
      "url": "/pop-culture/wow-void-elf-names"
    },
    {
      "name": "Vulpera",
      "fullName": "Vulpera",
      "slug": "wow-vulpera-names",
      "url": "/pop-culture/wow-vulpera-names"
    },
    {
      "name": "Zandalari Troll",
      "fullName": "Zandalari Troll",
      "slug": "wow-zandalari-troll-names",
      "url": "/pop-culture/wow-zandalari-troll-names"
    }
  ],
  "lotr-hobbit-names": [
    {
      "name": "Hobbit",
      "fullName": "Hobbit Names",
      "slug": "hobbit-names",
      "url": "/fantasy/hobbit-names"
    },
    {
      "name": "Balrog",
      "fullName": "Balrog",
      "slug": "lotr-balrog-names",
      "url": "/pop-culture/lotr-balrog-names"
    },
    {
      "name": "Beorning & Woodmen",
      "fullName": "Beorning & Woodmen",
      "slug": "lotr-beorning-woodmen-names",
      "url": "/pop-culture/lotr-beorning-woodmen-names"
    },
    {
      "name": "Bree",
      "fullName": "Bree",
      "slug": "lotr-bree-names",
      "url": "/pop-culture/lotr-bree-names"
    },
    {
      "name": "Dale",
      "fullName": "Dale",
      "slug": "lotr-dale-names",
      "url": "/pop-culture/lotr-dale-names"
    },
    {
      "name": "Druedáin",
      "fullName": "Druedáin",
      "slug": "lotr-druedain-names",
      "url": "/pop-culture/lotr-druedain-names"
    },
    {
      "name": "Dunlendings",
      "fullName": "Dunlendings",
      "slug": "lotr-dunlendings-names",
      "url": "/pop-culture/lotr-dunlendings-names"
    },
    {
      "name": "Dwarf",
      "fullName": "Dwarf",
      "slug": "lotr-dwarf-names",
      "url": "/pop-culture/lotr-dwarf-names"
    },
    {
      "name": "Hobbit",
      "fullName": "Hobbit",
      "slug": "lotr-hobbit-names",
      "url": "/pop-culture/lotr-hobbit-names"
    },
    {
      "name": "Maiar",
      "fullName": "Maiar",
      "slug": "lotr-maiar-names",
      "url": "/pop-culture/lotr-maiar-names"
    },
    {
      "name": "Orc",
      "fullName": "Orc",
      "slug": "lotr-orc-names",
      "url": "/pop-culture/lotr-orc-names"
    },
    {
      "name": "Quenya",
      "fullName": "Quenya",
      "slug": "lotr-quenya-names",
      "url": "/pop-culture/lotr-quenya-names"
    },
    {
      "name": "Rohirrim",
      "fullName": "Rohirrim",
      "slug": "lotr-rohirrim-names",
      "url": "/pop-culture/lotr-rohirrim-names"
    },
    {
      "name": "Sindarin",
      "fullName": "Sindarin",
      "slug": "lotr-sindarin-names",
      "url": "/pop-culture/lotr-sindarin-names"
    },
    {
      "name": "Hobbit",
      "fullName": "Hobbit",
      "slug": "hobbit-lotro-names",
      "url": "/pop-culture/hobbit-lotro-names"
    }
  ],
  "hp-wizard-names": [
    {
      "name": "Dragon Species",
      "fullName": "Dragon Species",
      "slug": "hp-dragon-species-names",
      "url": "/pop-culture/hp-dragon-species-names"
    },
    {
      "name": "Goblin",
      "fullName": "Goblin",
      "slug": "hp-goblin-names",
      "url": "/pop-culture/hp-goblin-names"
    },
    {
      "name": "House Elf",
      "fullName": "House Elf",
      "slug": "hp-house-elf-names",
      "url": "/pop-culture/hp-house-elf-names"
    },
    {
      "name": "Winged Horse",
      "fullName": "Winged Horse",
      "slug": "hp-winged-horse-names",
      "url": "/pop-culture/hp-winged-horse-names"
    },
    {
      "name": "Wizards",
      "fullName": "Wizards",
      "slug": "hp-wizard-names",
      "url": "/pop-culture/hp-wizard-names"
    },
    {
      "name": "Hippogriff",
      "fullName": "Hippogriff",
      "slug": "hp-hippogriff-names",
      "url": "/pop-culture/hp-hippogriff-names"
    },
    {
      "name": "Houses",
      "fullName": "Houses",
      "slug": "hp-house-names",
      "url": "/pop-culture/hp-house-names"
    },
    {
      "name": "Store",
      "fullName": "Store",
      "slug": "hp-store-names",
      "url": "/pop-culture/hp-store-names"
    }
  ],
  "got-westeros-names": [
    {
      "name": "Dothraki",
      "fullName": "Dothraki",
      "slug": "got-dothraki-names",
      "url": "/pop-culture/got-dothraki-names"
    },
    {
      "name": "Free Folk",
      "fullName": "Free Folk",
      "slug": "got-free-folk-names",
      "url": "/pop-culture/got-free-folk-names"
    },
    {
      "name": "Ghiscari",
      "fullName": "Ghiscari",
      "slug": "got-ghiscari-names",
      "url": "/pop-culture/got-ghiscari-names"
    },
    {
      "name": "Nick",
      "fullName": "Nicknames",
      "slug": "got-nicknames",
      "url": "/pop-culture/got-nicknames"
    },
    {
      "name": "Unsullied",
      "fullName": "Unsullied",
      "slug": "got-unsullied-names",
      "url": "/pop-culture/got-unsullied-names"
    },
    {
      "name": "Valyrian",
      "fullName": "Valyrian",
      "slug": "got-valyrian-names",
      "url": "/pop-culture/got-valyrian-names"
    },
    {
      "name": "Westeros",
      "fullName": "Westeros",
      "slug": "got-westeros-names",
      "url": "/pop-culture/got-westeros-names"
    },
    {
      "name": "Free City",
      "fullName": "Free City",
      "slug": "got-free-city-names",
      "url": "/pop-culture/got-free-city-names"
    },
    {
      "name": "Mountain Clan",
      "fullName": "Mountain Clan",
      "slug": "got-mountain-clan-names",
      "url": "/pop-culture/got-mountain-clan-names"
    },
    {
      "name": "Summer Islanders",
      "fullName": "Summer Islanders",
      "slug": "got-summer-islander-names",
      "url": "/pop-culture/got-summer-islander-names"
    }
  ],
  "the-witcher-aedirnian-names": [
    {
      "name": "Aedirnian",
      "fullName": "Aedirnian",
      "slug": "the-witcher-aedirnian-names",
      "url": "/pop-culture/the-witcher-aedirnian-names"
    },
    {
      "name": "Cidarian",
      "fullName": "Cidarian",
      "slug": "the-witcher-cidarian-names",
      "url": "/pop-culture/the-witcher-cidarian-names"
    },
    {
      "name": "Cintran",
      "fullName": "Cintran",
      "slug": "the-witcher-cintran-names",
      "url": "/pop-culture/the-witcher-cintran-names"
    },
    {
      "name": "Dwarf",
      "fullName": "Dwarf",
      "slug": "the-witcher-dwarf-names",
      "url": "/pop-culture/the-witcher-dwarf-names"
    },
    {
      "name": "Elf",
      "fullName": "Elf",
      "slug": "the-witcher-elf-names",
      "url": "/pop-culture/the-witcher-elf-names"
    },
    {
      "name": "Halfling",
      "fullName": "Halfling",
      "slug": "the-witcher-halfling-names",
      "url": "/pop-culture/the-witcher-halfling-names"
    },
    {
      "name": "Gnome",
      "fullName": "Gnome",
      "slug": "the-witcher-gnome-names",
      "url": "/pop-culture/the-witcher-gnome-names"
    },
    {
      "name": "Kaedwenian",
      "fullName": "Kaedwenian",
      "slug": "the-witcher-kaedwenian-names",
      "url": "/pop-culture/the-witcher-kaedwenian-names"
    },
    {
      "name": "Kovirian",
      "fullName": "Kovirian",
      "slug": "the-witcher-kovirian-names",
      "url": "/pop-culture/the-witcher-kovirian-names"
    },
    {
      "name": "Lyria & Rivia",
      "fullName": "Lyria & Rivia",
      "slug": "the-witcher-lyrian-rivian-names",
      "url": "/pop-culture/the-witcher-lyrian-rivian-names"
    },
    {
      "name": "Monster",
      "fullName": "Monster",
      "slug": "the-witcher-monster-names",
      "url": "/pop-culture/the-witcher-monster-names"
    },
    {
      "name": "Nilfgaardian",
      "fullName": "Nilfgaardian",
      "slug": "the-witcher-nilfgaardian-names",
      "url": "/pop-culture/the-witcher-nilfgaardian-names"
    },
    {
      "name": "Redanian",
      "fullName": "Redanian",
      "slug": "the-witcher-redanian-names",
      "url": "/pop-culture/the-witcher-redanian-names"
    },
    {
      "name": "Skellige",
      "fullName": "Skellige",
      "slug": "the-witcher-skelligan-names",
      "url": "/pop-culture/the-witcher-skelligan-names"
    },
    {
      "name": "Temerian",
      "fullName": "Temerian",
      "slug": "the-witcher-temerian-names",
      "url": "/pop-culture/the-witcher-temerian-names"
    },
    {
      "name": "Verdenian",
      "fullName": "Verdenian",
      "slug": "the-witcher-verdenian-names",
      "url": "/pop-culture/the-witcher-verdenian-names"
    }
  ],
  "zelda-deity-names": [
    {
      "name": "Anouki",
      "fullName": "Anouki",
      "slug": "zelda-anouki-names",
      "url": "/pop-culture/zelda-anouki-names"
    },
    {
      "name": "Blin",
      "fullName": "Blin",
      "slug": "zelda-blin-names",
      "url": "/pop-culture/zelda-blin-names"
    },
    {
      "name": "Deities",
      "fullName": "Deities",
      "slug": "zelda-deity-names",
      "url": "/pop-culture/zelda-deity-names"
    },
    {
      "name": "Deku",
      "fullName": "Deku",
      "slug": "zelda-deku-names",
      "url": "/pop-culture/zelda-deku-names"
    },
    {
      "name": "Dragons",
      "fullName": "Dragons",
      "slug": "zelda-dragon-names",
      "url": "/pop-culture/zelda-dragon-names"
    },
    {
      "name": "Fairies",
      "fullName": "Fairies",
      "slug": "zelda-fairy-names",
      "url": "/pop-culture/zelda-fairy-names"
    },
    {
      "name": "Gerudo",
      "fullName": "Gerudo",
      "slug": "zelda-gerudo-names",
      "url": "/pop-culture/zelda-gerudo-names"
    },
    {
      "name": "Goron",
      "fullName": "Goron",
      "slug": "zelda-goron-names",
      "url": "/pop-culture/zelda-goron-names"
    },
    {
      "name": "Humans",
      "fullName": "Humans",
      "slug": "zelda-human-names",
      "url": "/pop-culture/zelda-human-names"
    },
    {
      "name": "Korok & Kokiri",
      "fullName": "Korok & Kokiri",
      "slug": "zelda-korok-kokiri-names",
      "url": "/pop-culture/zelda-korok-kokiri-names"
    },
    {
      "name": "Minish",
      "fullName": "Minish",
      "slug": "zelda-minish-names",
      "url": "/pop-culture/zelda-minish-names"
    },
    {
      "name": "Rito",
      "fullName": "Rito",
      "slug": "zelda-rito-names",
      "url": "/pop-culture/zelda-rito-names"
    },
    {
      "name": "Sheikah",
      "fullName": "Sheikah",
      "slug": "zelda-sheikah-names",
      "url": "/pop-culture/zelda-sheikah-names"
    },
    {
      "name": "Twili",
      "fullName": "Twili",
      "slug": "zelda-twili-names",
      "url": "/pop-culture/zelda-twili-names"
    },
    {
      "name": "Zora",
      "fullName": "Zora",
      "slug": "zelda-zora-names",
      "url": "/pop-culture/zelda-zora-names"
    }
  ],
  "pathfinder-aasimar-names": [
    {
      "name": "Aasimar",
      "fullName": "Aasimar",
      "slug": "pathfinder-aasimar-names",
      "url": "/pop-culture/pathfinder-aasimar-names"
    },
    {
      "name": "Anadi",
      "fullName": "Anadi",
      "slug": "pathfinder-anadi-names",
      "url": "/pop-culture/pathfinder-anadi-names"
    },
    {
      "name": "Android",
      "fullName": "Android",
      "slug": "pathfinder-android-names",
      "url": "/pop-culture/pathfinder-android-names"
    },
    {
      "name": "Athamaru",
      "fullName": "Athamaru",
      "slug": "pathfinder-athamaru-names",
      "url": "/pop-culture/pathfinder-athamaru-names"
    },
    {
      "name": "Automaton",
      "fullName": "Automaton",
      "slug": "pathfinder-automaton-names",
      "url": "/pop-culture/pathfinder-automaton-names"
    },
    {
      "name": "Awakened Animal",
      "fullName": "Awakened Animal",
      "slug": "pathfinder-awakened-animal-names",
      "url": "/pop-culture/pathfinder-awakened-animal-names"
    },
    {
      "name": "Azarketi",
      "fullName": "Azarketi",
      "slug": "pathfinder-azarketi-names",
      "url": "/pop-culture/pathfinder-azarketi-names"
    },
    {
      "name": "Catfolk",
      "fullName": "Catfolk",
      "slug": "pathfinder-catfolk-names",
      "url": "/pop-culture/pathfinder-catfolk-names"
    },
    {
      "name": "Centaur",
      "fullName": "Centaur",
      "slug": "pathfinder-centaur-names",
      "url": "/pop-culture/pathfinder-centaur-names"
    },
    {
      "name": "Conrasu",
      "fullName": "Conrasu",
      "slug": "pathfinder-conrasu-names",
      "url": "/pop-culture/pathfinder-conrasu-names"
    },
    {
      "name": "Dragonet",
      "fullName": "Dragonet",
      "slug": "pathfinder-dragonet-names",
      "url": "/pop-culture/pathfinder-dragonet-names"
    },
    {
      "name": "Drow",
      "fullName": "Drow",
      "slug": "pathfinder-drow-names",
      "url": "/pop-culture/pathfinder-drow-names"
    },
    {
      "name": "Dwarf",
      "fullName": "Dwarf",
      "slug": "pathfinder-dwarf-names",
      "url": "/pop-culture/pathfinder-dwarf-names"
    },
    {
      "name": "Elf",
      "fullName": "Elf",
      "slug": "pathfinder-elf-names",
      "url": "/pop-culture/pathfinder-elf-names"
    },
    {
      "name": "Fetchling",
      "fullName": "Fetchling",
      "slug": "pathfinder-fetchling-names",
      "url": "/pop-culture/pathfinder-fetchling-names"
    },
    {
      "name": "Fleshwarp",
      "fullName": "Fleshwarp",
      "slug": "pathfinder-fleshwarp-names",
      "url": "/pop-culture/pathfinder-fleshwarp-names"
    },
    {
      "name": "Gathlain",
      "fullName": "Gathlain",
      "slug": "pathfinder-gathlain-names",
      "url": "/pop-culture/pathfinder-gathlain-names"
    },
    {
      "name": "Ghoran",
      "fullName": "Ghoran",
      "slug": "pathfinder-ghoran-names",
      "url": "/pop-culture/pathfinder-ghoran-names"
    },
    {
      "name": "Gnome",
      "fullName": "Gnome",
      "slug": "pathfinder-gnome-names",
      "url": "/pop-culture/pathfinder-gnome-names"
    },
    {
      "name": "Goblin",
      "fullName": "Goblin",
      "slug": "pathfinder-goblin-names",
      "url": "/pop-culture/pathfinder-goblin-names"
    },
    {
      "name": "Goloma",
      "fullName": "Goloma",
      "slug": "pathfinder-goloma-names",
      "url": "/pop-culture/pathfinder-goloma-names"
    },
    {
      "name": "Half-Elf",
      "fullName": "Half-Elf",
      "slug": "pathfinder-half-elf-names",
      "url": "/pop-culture/pathfinder-half-elf-names"
    },
    {
      "name": "Half-Orc",
      "fullName": "Half-Orc",
      "slug": "pathfinder-half-orc-names",
      "url": "/pop-culture/pathfinder-half-orc-names"
    },
    {
      "name": "Halfling",
      "fullName": "Halfling",
      "slug": "pathfinder-halfling-names",
      "url": "/pop-culture/pathfinder-halfling-names"
    },
    {
      "name": "Hobgoblin",
      "fullName": "Hobgoblin",
      "slug": "pathfinder-hobgoblin-names",
      "url": "/pop-culture/pathfinder-hobgoblin-names"
    },
    {
      "name": "Human",
      "fullName": "Human",
      "slug": "pathfinder-human-names",
      "url": "/pop-culture/pathfinder-human-names"
    },
    {
      "name": "Ifrit",
      "fullName": "Ifrit",
      "slug": "pathfinder-ifrit-names",
      "url": "/pop-culture/pathfinder-ifrit-names"
    },
    {
      "name": "Jotunborn",
      "fullName": "Jotunborn",
      "slug": "pathfinder-jotunborn-names",
      "url": "/pop-culture/pathfinder-jotunborn-names"
    },
    {
      "name": "Kashrishi",
      "fullName": "Kashrishi",
      "slug": "pathfinder-kashrishi-names",
      "url": "/pop-culture/pathfinder-kashrishi-names"
    },
    {
      "name": "Kholo",
      "fullName": "Kholo",
      "slug": "pathfinder-kholo-names",
      "url": "/pop-culture/pathfinder-kholo-names"
    },
    {
      "name": "Kitsune",
      "fullName": "Kitsune",
      "slug": "pathfinder-kitsune-names",
      "url": "/pop-culture/pathfinder-kitsune-names"
    },
    {
      "name": "Kobold",
      "fullName": "Kobold",
      "slug": "pathfinder-kobold-names",
      "url": "/pop-culture/pathfinder-kobold-names"
    },
    {
      "name": "Leshy",
      "fullName": "Leshy",
      "slug": "pathfinder-leshy-names",
      "url": "/pop-culture/pathfinder-leshy-names"
    },
    {
      "name": "Lizardfolk",
      "fullName": "Lizardfolk",
      "slug": "pathfinder-lizardfolk-names",
      "url": "/pop-culture/pathfinder-lizardfolk-names"
    },
    {
      "name": "Merfolk",
      "fullName": "Merfolk",
      "slug": "pathfinder-merfolk-names",
      "url": "/pop-culture/pathfinder-merfolk-names"
    },
    {
      "name": "Minotaur",
      "fullName": "Minotaur",
      "slug": "pathfinder-minotaur-names",
      "url": "/pop-culture/pathfinder-minotaur-names"
    },
    {
      "name": "Nagaji",
      "fullName": "Nagaji",
      "slug": "pathfinder-nagaji-names",
      "url": "/pop-culture/pathfinder-nagaji-names"
    },
    {
      "name": "Orc",
      "fullName": "Orc",
      "slug": "pathfinder-orc-names",
      "url": "/pop-culture/pathfinder-orc-names"
    },
    {
      "name": "Oread",
      "fullName": "Oread",
      "slug": "pathfinder-oread-names",
      "url": "/pop-culture/pathfinder-oread-names"
    },
    {
      "name": "Poppet",
      "fullName": "Poppet",
      "slug": "pathfinder-poppet-names",
      "url": "/pop-culture/pathfinder-poppet-names"
    },
    {
      "name": "Ratfolk",
      "fullName": "Ratfolk",
      "slug": "pathfinder-ratfolk-names",
      "url": "/pop-culture/pathfinder-ratfolk-names"
    },
    {
      "name": "Samsaran",
      "fullName": "Samsaran",
      "slug": "pathfinder-samsaran-names",
      "url": "/pop-culture/pathfinder-samsaran-names"
    },
    {
      "name": "Sarangay",
      "fullName": "Sarangay",
      "slug": "pathfinder-sarangay-names",
      "url": "/pop-culture/pathfinder-sarangay-names"
    },
    {
      "name": "Shisk",
      "fullName": "Shisk",
      "slug": "pathfinder-shisk-names",
      "url": "/pop-culture/pathfinder-shisk-names"
    },
    {
      "name": "Shoony",
      "fullName": "Shoony",
      "slug": "pathfinder-shoony-names",
      "url": "/pop-culture/pathfinder-shoony-names"
    },
    {
      "name": "Skeleton",
      "fullName": "Skeleton",
      "slug": "pathfinder-skeleton-names",
      "url": "/pop-culture/pathfinder-skeleton-names"
    },
    {
      "name": "Skinwalker",
      "fullName": "Skinwalker",
      "slug": "pathfinder-skinwalker-names",
      "url": "/pop-culture/pathfinder-skinwalker-names"
    },
    {
      "name": "Sprite",
      "fullName": "Sprite",
      "slug": "pathfinder-sprite-names",
      "url": "/pop-culture/pathfinder-sprite-names"
    },
    {
      "name": "Strix",
      "fullName": "Strix",
      "slug": "pathfinder-strix-names",
      "url": "/pop-culture/pathfinder-strix-names"
    },
    {
      "name": "Surki",
      "fullName": "Surki",
      "slug": "pathfinder-surki-names",
      "url": "/pop-culture/pathfinder-surki-names"
    },
    {
      "name": "Sylph",
      "fullName": "Sylph",
      "slug": "pathfinder-sylph-names",
      "url": "/pop-culture/pathfinder-sylph-names"
    },
    {
      "name": "Tanuki",
      "fullName": "Tanuki",
      "slug": "pathfinder-tanuki-names",
      "url": "/pop-culture/pathfinder-tanuki-names"
    },
    {
      "name": "Tengu",
      "fullName": "Tengu",
      "slug": "pathfinder-tengu-names",
      "url": "/pop-culture/pathfinder-tengu-names"
    },
    {
      "name": "Tian",
      "fullName": "Tian",
      "slug": "pathfinder-tian-names",
      "url": "/pop-culture/pathfinder-tian-names"
    },
    {
      "name": "Tiefling",
      "fullName": "Tiefling",
      "slug": "pathfinder-tiefling-names",
      "url": "/pop-culture/pathfinder-tiefling-names"
    },
    {
      "name": "Tripkee",
      "fullName": "Tripkee",
      "slug": "pathfinder-tripkee-names",
      "url": "/pop-culture/pathfinder-tripkee-names"
    },
    {
      "name": "Undine",
      "fullName": "Undine",
      "slug": "pathfinder-undine-names",
      "url": "/pop-culture/pathfinder-undine-names"
    },
    {
      "name": "Vanara",
      "fullName": "Vanara",
      "slug": "pathfinder-vanara-names",
      "url": "/pop-culture/pathfinder-vanara-names"
    },
    {
      "name": "Vishkanya",
      "fullName": "Vishkanya",
      "slug": "pathfinder-vishkanya-names",
      "url": "/pop-culture/pathfinder-vishkanya-names"
    },
    {
      "name": "Wayang",
      "fullName": "Wayang",
      "slug": "pathfinder-wayang-names",
      "url": "/pop-culture/pathfinder-wayang-names"
    },
    {
      "name": "Yaksha",
      "fullName": "Yaksha",
      "slug": "pathfinder-yaksha-names",
      "url": "/pop-culture/pathfinder-yaksha-names"
    },
    {
      "name": "Yaoguai",
      "fullName": "Yaoguai",
      "slug": "pathfinder-yaoguai-names",
      "url": "/pop-culture/pathfinder-yaoguai-names"
    }
  ],
  "warhammer-dwarf-names": [
    {
      "name": "Beastmen",
      "fullName": "Beastmen",
      "slug": "warhammer-beastmen-names",
      "url": "/pop-culture/warhammer-beastmen-names"
    },
    {
      "name": "Bretonnia",
      "fullName": "Bretonnia",
      "slug": "warhammer-bretonnia-names",
      "url": "/pop-culture/warhammer-bretonnia-names"
    },
    {
      "name": "Daemons of Chaos",
      "fullName": "Daemons of Chaos",
      "slug": "warhammer-daemons-of-chaos-names",
      "url": "/pop-culture/warhammer-daemons-of-chaos-names"
    },
    {
      "name": "Dark Elf",
      "fullName": "Dark Elf",
      "slug": "warhammer-dark-elf-names",
      "url": "/pop-culture/warhammer-dark-elf-names"
    },
    {
      "name": "Dwarf",
      "fullName": "Dwarf",
      "slug": "warhammer-dwarf-names",
      "url": "/pop-culture/warhammer-dwarf-names"
    },
    {
      "name": "Empire",
      "fullName": "Empire",
      "slug": "warhammer-empire-names",
      "url": "/pop-culture/warhammer-empire-names"
    },
    {
      "name": "Goblin",
      "fullName": "Goblin",
      "slug": "warhammer-goblin-names",
      "url": "/pop-culture/warhammer-goblin-names"
    },
    {
      "name": "High Elf",
      "fullName": "High Elf",
      "slug": "warhammer-high-elf-names",
      "url": "/pop-culture/warhammer-high-elf-names"
    },
    {
      "name": "Lizardmen",
      "fullName": "Lizardmen",
      "slug": "warhammer-lizardmen-names",
      "url": "/pop-culture/warhammer-lizardmen-names"
    },
    {
      "name": "Ogre",
      "fullName": "Ogre",
      "slug": "warhammer-ogre-names",
      "url": "/pop-culture/warhammer-ogre-names"
    },
    {
      "name": "Orc",
      "fullName": "Orc",
      "slug": "warhammer-orc-names",
      "url": "/pop-culture/warhammer-orc-names"
    },
    {
      "name": "Skaven",
      "fullName": "Skaven",
      "slug": "warhammer-skaven-names",
      "url": "/pop-culture/warhammer-skaven-names"
    },
    {
      "name": "Tomb King",
      "fullName": "Tomb King",
      "slug": "warhammer-tomb-kings-names",
      "url": "/pop-culture/warhammer-tomb-kings-names"
    },
    {
      "name": "Vampire Count",
      "fullName": "Vampire Count",
      "slug": "warhammer-vampire-count-names",
      "url": "/pop-culture/warhammer-vampire-count-names"
    },
    {
      "name": "Warriors of Chaos",
      "fullName": "Warriors of Chaos",
      "slug": "warhammer-warriors-of-chaos-names",
      "url": "/pop-culture/warhammer-warriors-of-chaos-names"
    },
    {
      "name": "Wood Elf",
      "fullName": "Wood Elf",
      "slug": "warhammer-wood-elf-names",
      "url": "/pop-culture/warhammer-wood-elf-names"
    }
  ],
  "warhammer-daemons-of-chaos-names": [
    {
      "name": "Chaos",
      "fullName": "Chaos",
      "slug": "warhammer-40k-chaos-names",
      "url": "/pop-culture/warhammer-40k-chaos-names"
    },
    {
      "name": "Dark Eldar",
      "fullName": "Dark Eldar",
      "slug": "warhammer-40k-dark-eldar-names",
      "url": "/pop-culture/warhammer-40k-dark-eldar-names"
    },
    {
      "name": "Eldar",
      "fullName": "Eldar",
      "slug": "warhammer-40k-eldar-names",
      "url": "/pop-culture/warhammer-40k-eldar-names"
    },
    {
      "name": "Necron",
      "fullName": "Necron",
      "slug": "warhammer-40k-necron-names",
      "url": "/pop-culture/warhammer-40k-necron-names"
    },
    {
      "name": "Ork",
      "fullName": "Ork",
      "slug": "warhammer-40k-ork-names",
      "url": "/pop-culture/warhammer-40k-ork-names"
    },
    {
      "name": "Sisters of Battle",
      "fullName": "Sisters of Battle",
      "slug": "warhammer-40k-sisters-of-battle-names",
      "url": "/pop-culture/warhammer-40k-sisters-of-battle-names"
    },
    {
      "name": "Space Marine",
      "fullName": "Space Marine",
      "slug": "warhammer-40k-space-marine-names",
      "url": "/pop-culture/warhammer-40k-space-marine-names"
    },
    {
      "name": "Tau",
      "fullName": "Tau",
      "slug": "warhammer-40k-tau-names",
      "url": "/pop-culture/warhammer-40k-tau-names"
    }
  ],
  "avatar-tla-names": [
    {
      "name": "The Last Airbender",
      "fullName": "Avatar: The Last Airbender",
      "slug": "avatar-tla-names",
      "url": "/pop-culture/avatar-tla-names"
    },
    {
      "name": "Air Nomad",
      "fullName": "Air Nomad",
      "slug": "avatar-air-nomad-names",
      "url": "/pop-culture/avatar-air-nomad-names"
    },
    {
      "name": "Earth Kingdom",
      "fullName": "Earth Kingdom",
      "slug": "avatar-earth-kingdom-names",
      "url": "/pop-culture/avatar-earth-kingdom-names"
    },
    {
      "name": "Fire Nation",
      "fullName": "Fire Nation",
      "slug": "avatar-fire-nation-names",
      "url": "/pop-culture/avatar-fire-nation-names"
    },
    {
      "name": "Water Tribe",
      "fullName": "Water Tribe",
      "slug": "avatar-water-tribe-names",
      "url": "/pop-culture/avatar-water-tribe-names"
    },
    {
      "name": "Animal Species",
      "fullName": "Animal Species",
      "slug": "avatar-animal-species-names",
      "url": "/pop-culture/avatar-animal-species-names"
    },
    {
      "name": "Dragons",
      "fullName": "Dragons",
      "slug": "avatar-dragon-names",
      "url": "/pop-culture/avatar-dragon-names"
    },
    {
      "name": "Earth Kingdom Places",
      "fullName": "Earth Kingdom Places",
      "slug": "avatar-earth-kingdom-place-names",
      "url": "/pop-culture/avatar-earth-kingdom-place-names"
    },
    {
      "name": "Fire Nation Places",
      "fullName": "Fire Nation Places",
      "slug": "avatar-fire-nation-place-names",
      "url": "/pop-culture/avatar-fire-nation-place-names"
    },
    {
      "name": "Foggy Swamp Tribe",
      "fullName": "Foggy Swamp Tribe",
      "slug": "avatar-foggy-swamp-tribe-names",
      "url": "/pop-culture/avatar-foggy-swamp-tribe-names"
    },
    {
      "name": "Spirits",
      "fullName": "Spirits",
      "slug": "avatar-spirit-names",
      "url": "/pop-culture/avatar-spirit-names"
    },
    {
      "name": "Stores",
      "fullName": "Stores",
      "slug": "avatar-store-names",
      "url": "/pop-culture/avatar-store-names"
    }
  ],
  "bleach-names": [
    {
      "name": "Bleach",
      "fullName": "Bleach",
      "slug": "bleach-names",
      "url": "/pop-culture/bleach-names"
    },
    {
      "name": "Arrancar",
      "fullName": "Arrancar",
      "slug": "bleach-arrancar-names",
      "url": "/pop-culture/bleach-arrancar-names"
    },
    {
      "name": "Bankai",
      "fullName": "Bankai",
      "slug": "bleach-bankai-names",
      "url": "/pop-culture/bleach-bankai-names"
    },
    {
      "name": "Hollow",
      "fullName": "Hollow",
      "slug": "bleach-hollow-names",
      "url": "/pop-culture/bleach-hollow-names"
    },
    {
      "name": "Quincy",
      "fullName": "Quincy",
      "slug": "bleach-quincy-names",
      "url": "/pop-culture/bleach-quincy-names"
    },
    {
      "name": "Shinigami",
      "fullName": "Shinigami",
      "slug": "bleach-shinigami-names",
      "url": "/pop-culture/bleach-shinigami-names"
    },
    {
      "name": "Zanpakuto",
      "fullName": "Zanpakuto",
      "slug": "bleach-zanpakuto-names",
      "url": "/pop-culture/bleach-zanpakuto-names"
    }
  ],
  "naruto-character-names": [
    {
      "name": "Characters",
      "fullName": "Characters",
      "slug": "naruto-character-names",
      "url": "/pop-culture/naruto-character-names"
    },
    {
      "name": "Clans",
      "fullName": "Clans",
      "slug": "naruto-clan-names",
      "url": "/pop-culture/naruto-clan-names"
    },
    {
      "name": "Dojutsu",
      "fullName": "Dojutsu",
      "slug": "naruto-dojutsu-names",
      "url": "/pop-culture/naruto-dojutsu-names"
    },
    {
      "name": "Jutsu",
      "fullName": "Jutsu",
      "slug": "naruto-jutsu-names",
      "url": "/pop-culture/naruto-jutsu-names"
    },
    {
      "name": "Towns",
      "fullName": "Towns",
      "slug": "naruto-town-names",
      "url": "/pop-culture/naruto-town-names"
    }
  ],
  "one-piece-character-names": [
    {
      "name": "Character",
      "fullName": "Character",
      "slug": "one-piece-character-names",
      "url": "/pop-culture/one-piece-character-names"
    },
    {
      "name": "Devil Fruit",
      "fullName": "Devil Fruit",
      "slug": "one-piece-devil-fruit-names",
      "url": "/pop-culture/one-piece-devil-fruit-names"
    },
    {
      "name": "Island",
      "fullName": "Island",
      "slug": "one-piece-island-names",
      "url": "/pop-culture/one-piece-island-names"
    },
    {
      "name": "Organization",
      "fullName": "Organization",
      "slug": "one-piece-organization-names",
      "url": "/pop-culture/one-piece-organization-names"
    },
    {
      "name": "Ship",
      "fullName": "Ship",
      "slug": "one-piece-ship-names",
      "url": "/pop-culture/one-piece-ship-names"
    }
  ],
  "jujutsu-kaisen-cursed-technique-names": [
    {
      "name": "Cursed Techniques",
      "fullName": "Cursed Techniques",
      "slug": "jujutsu-kaisen-cursed-technique-names",
      "url": "/pop-culture/jujutsu-kaisen-cursed-technique-names"
    },
    {
      "name": "Cursed Tools",
      "fullName": "Cursed Tools",
      "slug": "jujutsu-kaisen-cursed-tool-names",
      "url": "/pop-culture/jujutsu-kaisen-cursed-tool-names"
    },
    {
      "name": "Domain Expansion",
      "fullName": "Domain Expansion",
      "slug": "jujutsu-kaisen-domain-expansion-names",
      "url": "/pop-culture/jujutsu-kaisen-domain-expansion-names"
    }
  ],
  "marvel-celestial-names": [
    {
      "name": "Celestials",
      "fullName": "Celestials",
      "slug": "marvel-celestial-names",
      "url": "/pop-culture/marvel-celestial-names"
    },
    {
      "name": "Centaurian",
      "fullName": "Centaurian",
      "slug": "marvel-centaurian-names",
      "url": "/pop-culture/marvel-centaurian-names"
    },
    {
      "name": "Eternals",
      "fullName": "Eternals",
      "slug": "marvel-eternal-names",
      "url": "/pop-culture/marvel-eternal-names"
    },
    {
      "name": "Klyntar / Symbiote",
      "fullName": "Klyntar / Symbiote",
      "slug": "marvel-klyntar-symbiote-names",
      "url": "/pop-culture/marvel-klyntar-symbiote-names"
    },
    {
      "name": "Krees",
      "fullName": "Krees",
      "slug": "marvel-kree-names",
      "url": "/pop-culture/marvel-kree-names"
    },
    {
      "name": "Skrulls",
      "fullName": "Skrulls",
      "slug": "marvel-skrull-names",
      "url": "/pop-culture/marvel-skrull-names"
    },
    {
      "name": "Wakandans",
      "fullName": "Wakandans",
      "slug": "marvel-wakandan-names",
      "url": "/pop-culture/marvel-wakandan-names"
    },
    {
      "name": "Watcher",
      "fullName": "Watcher",
      "slug": "marvel-watcher-names",
      "url": "/pop-culture/marvel-watcher-names"
    },
    {
      "name": "Xandarians",
      "fullName": "Xandarians",
      "slug": "marvel-xandarian-names",
      "url": "/pop-culture/marvel-xandarian-names"
    }
  ],
  "dc-comics-names": [
    {
      "name": "Comics",
      "fullName": "DC Comics",
      "slug": "dc-comics-names",
      "url": "/pop-culture/dc-comics-names"
    },
    {
      "name": "Amazon",
      "fullName": "Amazon",
      "slug": "dc-amazon-names",
      "url": "/pop-culture/dc-amazon-names"
    },
    {
      "name": "Atlantean",
      "fullName": "Atlantean",
      "slug": "dc-atlantean-names",
      "url": "/pop-culture/dc-atlantean-names"
    },
    {
      "name": "Kryptonian",
      "fullName": "Kryptonian",
      "slug": "dc-kryptonian-names",
      "url": "/pop-culture/dc-kryptonian-names"
    },
    {
      "name": "Maltusian & Oan",
      "fullName": "Maltusian & Oan",
      "slug": "dc-oan-names",
      "url": "/pop-culture/dc-oan-names"
    },
    {
      "name": "Martian",
      "fullName": "Martian",
      "slug": "dc-martian-names",
      "url": "/pop-culture/dc-martian-names"
    },
    {
      "name": "Talokite",
      "fullName": "Talokite",
      "slug": "dc-talokite-names",
      "url": "/pop-culture/dc-talokite-names"
    },
    {
      "name": "Tamaranean",
      "fullName": "Tamaranean",
      "slug": "dc-tamaranean-names",
      "url": "/pop-culture/dc-tamaranean-names"
    },
    {
      "name": "Titanian & Winathian",
      "fullName": "Titanian & Winathian",
      "slug": "dc-titanian-winathian-names",
      "url": "/pop-culture/dc-titanian-winathian-names"
    },
    {
      "name": "Ungaran",
      "fullName": "Ungaran",
      "slug": "dc-ungaran-names",
      "url": "/pop-culture/dc-ungaran-names"
    },
    {
      "name": "Xudarian",
      "fullName": "Xudarian",
      "slug": "dc-xudarian-names",
      "url": "/pop-culture/dc-xudarian-names"
    }
  ],
  "halo-forerunner-names": [
    {
      "name": "Forerunner",
      "fullName": "Forerunner",
      "slug": "halo-forerunner-names",
      "url": "/pop-culture/halo-forerunner-names"
    },
    {
      "name": "Huragok",
      "fullName": "Huragok",
      "slug": "halo-huragok-names",
      "url": "/pop-culture/halo-huragok-names"
    },
    {
      "name": "Jiralhanae",
      "fullName": "Jiralhanae",
      "slug": "halo-jiralhanae-names",
      "url": "/pop-culture/halo-jiralhanae-names"
    },
    {
      "name": "Kig-Yar",
      "fullName": "Kig-Yar",
      "slug": "halo-kig-yar-names",
      "url": "/pop-culture/halo-kig-yar-names"
    },
    {
      "name": "Mgalekgolo",
      "fullName": "Mgalekgolo",
      "slug": "halo-mgalekgolo-names",
      "url": "/pop-culture/halo-mgalekgolo-names"
    },
    {
      "name": "Sangheili",
      "fullName": "Sangheili",
      "slug": "halo-sangheili-names",
      "url": "/pop-culture/halo-sangheili-names"
    },
    {
      "name": "San 'Shyuum",
      "fullName": "San 'Shyuum",
      "slug": "halo-san-shyuum-names",
      "url": "/pop-culture/halo-san-shyuum-names"
    },
    {
      "name": "Unggoy",
      "fullName": "Unggoy",
      "slug": "halo-unggoy-names",
      "url": "/pop-culture/halo-unggoy-names"
    }
  ],
  "asari-names": [
    {
      "name": "Asari",
      "fullName": "Asari",
      "slug": "asari-names",
      "url": "/other-names/asari-names"
    },
    {
      "name": "Krogan",
      "fullName": "Krogan",
      "slug": "krogan-names",
      "url": "/other-names/krogan-names"
    },
    {
      "name": "Turian",
      "fullName": "Turian",
      "slug": "turian-names",
      "url": "/other-names/turian-names"
    }
  ],
  "fallout-names": [
    {
      "name": "Fallout",
      "fullName": "Fallout",
      "slug": "fallout-names",
      "url": "/pop-culture/fallout-names"
    },
    {
      "name": "Characters",
      "fullName": "Characters",
      "slug": "fallout-character-names",
      "url": "/pop-culture/fallout-character-names"
    },
    {
      "name": "Crews & Factions",
      "fullName": "Crews & Factions",
      "slug": "fallout-crew-names",
      "url": "/pop-culture/fallout-crew-names"
    },
    {
      "name": "Synths",
      "fullName": "Synths",
      "slug": "fallout-synth-names",
      "url": "/pop-culture/fallout-synth-names"
    },
    {
      "name": "Titles",
      "fullName": "Titles",
      "slug": "fallout-character-titles",
      "url": "/pop-culture/fallout-character-titles"
    }
  ],
  "narnia-dwarf-names": [
    {
      "name": "Centaur",
      "fullName": "Centaur",
      "slug": "narnia-centaur-names",
      "url": "/pop-culture/narnia-centaur-names"
    },
    {
      "name": "Dwarf",
      "fullName": "Dwarf",
      "slug": "narnia-dwarf-names",
      "url": "/pop-culture/narnia-dwarf-names"
    },
    {
      "name": "Faun",
      "fullName": "Faun",
      "slug": "narnia-faun-names",
      "url": "/pop-culture/narnia-faun-names"
    },
    {
      "name": "Giant",
      "fullName": "Giant",
      "slug": "narnia-giant-names",
      "url": "/pop-culture/narnia-giant-names"
    },
    {
      "name": "Horse",
      "fullName": "Horse",
      "slug": "narnia-horse-names",
      "url": "/pop-culture/narnia-horse-names"
    },
    {
      "name": "Minotaur",
      "fullName": "Minotaur",
      "slug": "narnia-minotaur-names",
      "url": "/pop-culture/narnia-minotaur-names"
    },
    {
      "name": "Satyr",
      "fullName": "Satyr",
      "slug": "narnia-satyr-names",
      "url": "/pop-culture/narnia-satyr-names"
    },
    {
      "name": "Badger",
      "fullName": "Badger",
      "slug": "narnia-badger-names",
      "url": "/pop-culture/narnia-badger-names"
    },
    {
      "name": "Calormen",
      "fullName": "Calormen",
      "slug": "narnia-calormen-names",
      "url": "/pop-culture/narnia-calormen-names"
    },
    {
      "name": "Hedgehog",
      "fullName": "Hedgehog",
      "slug": "narnia-hedgehog-names",
      "url": "/pop-culture/narnia-hedgehog-names"
    },
    {
      "name": "Mole",
      "fullName": "Mole",
      "slug": "narnia-mole-names",
      "url": "/pop-culture/narnia-mole-names"
    },
    {
      "name": "Mouse",
      "fullName": "Mouse",
      "slug": "narnia-mouse-names",
      "url": "/pop-culture/narnia-mouse-names"
    },
    {
      "name": "Owl",
      "fullName": "Owl",
      "slug": "narnia-owl-names",
      "url": "/pop-culture/narnia-owl-names"
    },
    {
      "name": "Squirrel",
      "fullName": "Squirrel",
      "slug": "narnia-squirrel-names",
      "url": "/pop-culture/narnia-squirrel-names"
    },
    {
      "name": "Telmar",
      "fullName": "Telmar",
      "slug": "narnia-telmar-names",
      "url": "/pop-culture/narnia-telmar-names"
    },
    {
      "name": "Wolf",
      "fullName": "Wolf",
      "slug": "narnia-wolf-names",
      "url": "/pop-culture/narnia-wolf-names"
    },
    {
      "name": "Archenlander",
      "fullName": "Archenlander",
      "slug": "narnia-archenlander-names",
      "url": "/pop-culture/narnia-archenlander-names"
    },
    {
      "name": "Star",
      "fullName": "Star",
      "slug": "narnia-star-names",
      "url": "/pop-culture/narnia-star-names"
    }
  ],
  "percy-jackson-demigod-names": [
    {
      "name": "Centaur",
      "fullName": "Centaur",
      "slug": "percy-jackson-centaur-names",
      "url": "/pop-culture/percy-jackson-centaur-names"
    },
    {
      "name": "Demigod",
      "fullName": "Demigod",
      "slug": "percy-jackson-demigod-names",
      "url": "/pop-culture/percy-jackson-demigod-names"
    },
    {
      "name": "Dwarf",
      "fullName": "Dwarf",
      "slug": "percy-jackson-dwarf-names",
      "url": "/pop-culture/percy-jackson-dwarf-names"
    },
    {
      "name": "Jötnar",
      "fullName": "Jötnar",
      "slug": "percy-jackson-jotnar-names",
      "url": "/pop-culture/percy-jackson-jotnar-names"
    },
    {
      "name": "Troglodyte",
      "fullName": "Troglodyte",
      "slug": "percy-jackson-troglodyte-names",
      "url": "/pop-culture/percy-jackson-troglodyte-names"
    }
  ],
  "inheritance-cycle-dragon-names": [
    {
      "name": "Dragon",
      "fullName": "Dragon",
      "slug": "inheritance-cycle-dragon-names",
      "url": "/pop-culture/inheritance-cycle-dragon-names"
    },
    {
      "name": "Dwarf",
      "fullName": "Dwarf",
      "slug": "inheritance-cycle-dwarf-names",
      "url": "/pop-culture/inheritance-cycle-dwarf-names"
    },
    {
      "name": "Elf",
      "fullName": "Elf",
      "slug": "inheritance-cycle-elf-names",
      "url": "/pop-culture/inheritance-cycle-elf-names"
    },
    {
      "name": "Human",
      "fullName": "Human",
      "slug": "inheritance-cycle-human-names",
      "url": "/pop-culture/inheritance-cycle-human-names"
    },
    {
      "name": "Urgal",
      "fullName": "Urgal",
      "slug": "inheritance-cycle-urgal-names",
      "url": "/pop-culture/inheritance-cycle-urgal-names"
    }
  ],
  "mistborn-kandra-names": [
    {
      "name": "Kandra",
      "fullName": "Kandra",
      "slug": "mistborn-kandra-names",
      "url": "/pop-culture/mistborn-kandra-names"
    },
    {
      "name": "Nobility",
      "fullName": "Nobility",
      "slug": "mistborn-nobility-names",
      "url": "/pop-culture/mistborn-nobility-names"
    },
    {
      "name": "Skaa",
      "fullName": "Skaa",
      "slug": "mistborn-skaa-names",
      "url": "/pop-culture/mistborn-skaa-names"
    },
    {
      "name": "Terris",
      "fullName": "Terris",
      "slug": "mistborn-terris-names",
      "url": "/pop-culture/mistborn-terris-names"
    }
  ],
  "destiny-names": [
    {
      "name": "Destiny",
      "fullName": "Destiny",
      "slug": "destiny-names",
      "url": "/pop-culture/destiny-names"
    },
    {
      "name": "Awoken",
      "fullName": "Awoken",
      "slug": "destiny-awoken-names",
      "url": "/pop-culture/destiny-awoken-names"
    },
    {
      "name": "Cabal",
      "fullName": "Cabal",
      "slug": "destiny-cabal-names",
      "url": "/pop-culture/destiny-cabal-names"
    },
    {
      "name": "Exo",
      "fullName": "Exo",
      "slug": "destiny-exo-names",
      "url": "/pop-culture/destiny-exo-names"
    },
    {
      "name": "Fallen",
      "fullName": "Fallen",
      "slug": "destiny-fallen-names",
      "url": "/pop-culture/destiny-fallen-names"
    },
    {
      "name": "Hive",
      "fullName": "Hive",
      "slug": "destiny-hive-names",
      "url": "/pop-culture/destiny-hive-names"
    },
    {
      "name": "Human",
      "fullName": "Human",
      "slug": "destiny-human-names",
      "url": "/pop-culture/destiny-human-names"
    },
    {
      "name": "Psion",
      "fullName": "Psion",
      "slug": "destiny-psion-names",
      "url": "/pop-culture/destiny-psion-names"
    },
    {
      "name": "Vex",
      "fullName": "Vex",
      "slug": "destiny-vex-names",
      "url": "/pop-culture/destiny-vex-names"
    }
  ],
  "pokemon-names": [
    {
      "name": "Descriptions",
      "fullName": "Pokemon Descriptions",
      "slug": "pokemon-descriptions",
      "url": "/pop-culture/pokemon-descriptions"
    },
    {
      "name": "Pokemon Names",
      "fullName": "Pokemon Names",
      "slug": "pokemon-names",
      "url": "/pop-culture/pokemon-names"
    }
  ],
  "sonic-mobian-names": [
    {
      "name": "Boss",
      "fullName": "Boss",
      "slug": "sonic-boss-names",
      "url": "/pop-culture/sonic-boss-names"
    },
    {
      "name": "Chao",
      "fullName": "Chao",
      "slug": "sonic-chao-names",
      "url": "/pop-culture/sonic-chao-names"
    },
    {
      "name": "Humans",
      "fullName": "Humans",
      "slug": "sonic-human-names",
      "url": "/pop-culture/sonic-human-names"
    },
    {
      "name": "Mobians",
      "fullName": "Mobians",
      "slug": "sonic-mobian-names",
      "url": "/pop-culture/sonic-mobian-names"
    },
    {
      "name": "Zones",
      "fullName": "Zones",
      "slug": "sonic-zone-names",
      "url": "/pop-culture/sonic-zone-names"
    }
  ],
  "runescape-dwarf-names": [
    {
      "name": "Aviansie",
      "fullName": "Aviansie",
      "slug": "runescape-aviansie-names",
      "url": "/pop-culture/runescape-aviansie-names"
    },
    {
      "name": "Demons",
      "fullName": "Demons",
      "slug": "runescape-demon-names",
      "url": "/pop-culture/runescape-demon-names"
    },
    {
      "name": "Dorgeshuun",
      "fullName": "Dorgeshuun",
      "slug": "runescape-dorgeshuun-names",
      "url": "/pop-culture/runescape-dorgeshuun-names"
    },
    {
      "name": "Dragonkin",
      "fullName": "Dragonkin",
      "slug": "runescape-dragonkin-names",
      "url": "/pop-culture/runescape-dragonkin-names"
    },
    {
      "name": "Dragons",
      "fullName": "Dragons",
      "slug": "runescape-dragon-names",
      "url": "/pop-culture/runescape-dragon-names"
    },
    {
      "name": "Dwarves",
      "fullName": "Dwarves",
      "slug": "runescape-dwarf-names",
      "url": "/pop-culture/runescape-dwarf-names"
    },
    {
      "name": "Elves",
      "fullName": "Elves",
      "slug": "runescape-elf-names",
      "url": "/pop-culture/runescape-elf-names"
    },
    {
      "name": "Gnomes",
      "fullName": "Gnomes",
      "slug": "runescape-gnome-names",
      "url": "/pop-culture/runescape-gnome-names"
    },
    {
      "name": "Goblins",
      "fullName": "Goblins",
      "slug": "runescape-goblin-names",
      "url": "/pop-culture/runescape-goblin-names"
    },
    {
      "name": "Icyene",
      "fullName": "Icyene",
      "slug": "runescape-icyene-names",
      "url": "/pop-culture/runescape-icyene-names"
    },
    {
      "name": "Ilujanka",
      "fullName": "Ilujanka",
      "slug": "runescape-ilujanka-names",
      "url": "/pop-culture/runescape-ilujanka-names"
    },
    {
      "name": "Monkey",
      "fullName": "Monkey",
      "slug": "runescape-monkey-names",
      "url": "/pop-culture/runescape-monkey-names"
    },
    {
      "name": "Naragi",
      "fullName": "Naragi",
      "slug": "runescape-naragi-names",
      "url": "/pop-culture/runescape-naragi-names"
    },
    {
      "name": "Trolls",
      "fullName": "Trolls",
      "slug": "runescape-troll-names",
      "url": "/pop-culture/runescape-troll-names"
    },
    {
      "name": "TokHaar & TzHaar",
      "fullName": "TokHaar & TzHaar",
      "slug": "runescape-tokhaar-tzhaar-names",
      "url": "/pop-culture/runescape-tokhaar-tzhaar-names"
    },
    {
      "name": "Vampyre",
      "fullName": "Vampyre",
      "slug": "runescape-vampyre-names",
      "url": "/pop-culture/runescape-vampyre-names"
    }
  ],
  "mtg-angel-names": [
    {
      "name": "Angel",
      "fullName": "Angel",
      "slug": "mtg-angel-names",
      "url": "/pop-culture/mtg-angel-names"
    },
    {
      "name": "Avatar",
      "fullName": "Avatar",
      "slug": "mtg-avatar-names",
      "url": "/pop-culture/mtg-avatar-names"
    },
    {
      "name": "Centaur",
      "fullName": "Centaur",
      "slug": "mtg-centaur-names",
      "url": "/pop-culture/mtg-centaur-names"
    },
    {
      "name": "Cephalid",
      "fullName": "Cephalid",
      "slug": "mtg-cephalid-names",
      "url": "/pop-culture/mtg-cephalid-names"
    },
    {
      "name": "Demon",
      "fullName": "Demon",
      "slug": "mtg-demon-names",
      "url": "/pop-culture/mtg-demon-names"
    },
    {
      "name": "Djinn",
      "fullName": "Djinn",
      "slug": "mtg-djinn-names",
      "url": "/pop-culture/mtg-djinn-names"
    },
    {
      "name": "Dryad",
      "fullName": "Dryad",
      "slug": "mtg-dryad-names",
      "url": "/pop-culture/mtg-dryad-names"
    },
    {
      "name": "Dragon",
      "fullName": "Dragon",
      "slug": "mtg-dragon-names",
      "url": "/pop-culture/mtg-dragon-names"
    },
    {
      "name": "Dwarf",
      "fullName": "Dwarf",
      "slug": "mtg-dwarf-names",
      "url": "/pop-culture/mtg-dwarf-names"
    },
    {
      "name": "Eldrazi",
      "fullName": "Eldrazi",
      "slug": "mtg-eldrazi-names",
      "url": "/pop-culture/mtg-eldrazi-names"
    },
    {
      "name": "Elemental",
      "fullName": "Elemental",
      "slug": "mtg-elemental-names",
      "url": "/pop-culture/mtg-elemental-names"
    },
    {
      "name": "Elf",
      "fullName": "Elf",
      "slug": "mtg-elf-names",
      "url": "/pop-culture/mtg-elf-names"
    },
    {
      "name": "Faerie",
      "fullName": "Faerie",
      "slug": "mtg-faerie-names",
      "url": "/pop-culture/mtg-faerie-names"
    },
    {
      "name": "Giant",
      "fullName": "Giant",
      "slug": "mtg-giant-names",
      "url": "/pop-culture/mtg-giant-names"
    },
    {
      "name": "Goblin",
      "fullName": "Goblin",
      "slug": "mtg-goblin-names",
      "url": "/pop-culture/mtg-goblin-names"
    },
    {
      "name": "God",
      "fullName": "God",
      "slug": "mtg-god-names",
      "url": "/pop-culture/mtg-god-names"
    },
    {
      "name": "Golem",
      "fullName": "Golem",
      "slug": "mtg-golem-names",
      "url": "/pop-culture/mtg-golem-names"
    },
    {
      "name": "Gorgon",
      "fullName": "Gorgon",
      "slug": "mtg-gorgon-names",
      "url": "/pop-culture/mtg-gorgon-names"
    },
    {
      "name": "Horror",
      "fullName": "Horror",
      "slug": "mtg-horror-names",
      "url": "/pop-culture/mtg-horror-names"
    },
    {
      "name": "Human",
      "fullName": "Human",
      "slug": "mtg-human-names",
      "url": "/pop-culture/mtg-human-names"
    },
    {
      "name": "Kithkin",
      "fullName": "Kithkin",
      "slug": "mtg-kithkin-names",
      "url": "/pop-culture/mtg-kithkin-names"
    },
    {
      "name": "Kor",
      "fullName": "Kor",
      "slug": "mtg-kor-names",
      "url": "/pop-culture/mtg-kor-names"
    },
    {
      "name": "Merfolk",
      "fullName": "Merfolk",
      "slug": "mtg-merfolk-names",
      "url": "/pop-culture/mtg-merfolk-names"
    },
    {
      "name": "Minotaur",
      "fullName": "Minotaur",
      "slug": "mtg-minotaur-names",
      "url": "/pop-culture/mtg-minotaur-names"
    },
    {
      "name": "Moonfolk",
      "fullName": "Moonfolk",
      "slug": "mtg-moonfolk-names",
      "url": "/pop-culture/mtg-moonfolk-names"
    },
    {
      "name": "Naga",
      "fullName": "Naga",
      "slug": "mtg-naga-names",
      "url": "/pop-culture/mtg-naga-names"
    },
    {
      "name": "Ogre",
      "fullName": "Ogre",
      "slug": "mtg-ogre-names",
      "url": "/pop-culture/mtg-ogre-names"
    },
    {
      "name": "Orc",
      "fullName": "Orc",
      "slug": "mtg-orc-names",
      "url": "/pop-culture/mtg-orc-names"
    },
    {
      "name": "Praetor",
      "fullName": "Praetor",
      "slug": "mtg-praetor-names",
      "url": "/pop-culture/mtg-praetor-names"
    },
    {
      "name": "Sphinx",
      "fullName": "Sphinx",
      "slug": "mtg-sphinx-names",
      "url": "/pop-culture/mtg-sphinx-names"
    },
    {
      "name": "Treefolk",
      "fullName": "Treefolk",
      "slug": "mtg-treefolk-names",
      "url": "/pop-culture/mtg-treefolk-names"
    },
    {
      "name": "Troll",
      "fullName": "Troll",
      "slug": "mtg-troll-names",
      "url": "/pop-culture/mtg-troll-names"
    },
    {
      "name": "Vampire",
      "fullName": "Vampire",
      "slug": "mtg-vampire-names",
      "url": "/pop-culture/mtg-vampire-names"
    }
  ],
  "minecraft-villager-names": [
    {
      "name": "Bats",
      "fullName": "Bats",
      "slug": "minecraft-bat-names",
      "url": "/pop-culture/minecraft-bat-names"
    },
    {
      "name": "Blazes",
      "fullName": "Blazes",
      "slug": "minecraft-blaze-names",
      "url": "/pop-culture/minecraft-blaze-names"
    },
    {
      "name": "Cats",
      "fullName": "Cats",
      "slug": "minecraft-cat-ocelot-names",
      "url": "/pop-culture/minecraft-cat-ocelot-names"
    },
    {
      "name": "Chickens",
      "fullName": "Chickens",
      "slug": "minecraft-chicken-names",
      "url": "/pop-culture/minecraft-chicken-names"
    },
    {
      "name": "Cows",
      "fullName": "Cows",
      "slug": "minecraft-cow-names",
      "url": "/pop-culture/minecraft-cow-names"
    },
    {
      "name": "Creepers",
      "fullName": "Creepers",
      "slug": "minecraft-creeper-names",
      "url": "/pop-culture/minecraft-creeper-names"
    },
    {
      "name": "Dolphins",
      "fullName": "Dolphins",
      "slug": "minecraft-dolphin-names",
      "url": "/pop-culture/minecraft-dolphin-names"
    },
    {
      "name": "Endermen",
      "fullName": "Endermen",
      "slug": "minecraft-enderman-names",
      "url": "/pop-culture/minecraft-enderman-names"
    },
    {
      "name": "Fish",
      "fullName": "Fish",
      "slug": "minecraft-fish-names",
      "url": "/pop-culture/minecraft-fish-names"
    },
    {
      "name": "Foxes",
      "fullName": "Foxes",
      "slug": "minecraft-fox-names",
      "url": "/pop-culture/minecraft-fox-names"
    },
    {
      "name": "Ghasts",
      "fullName": "Ghasts",
      "slug": "minecraft-ghast-names",
      "url": "/pop-culture/minecraft-ghast-names"
    },
    {
      "name": "Horses & Donkeys",
      "fullName": "Horses & Donkeys",
      "slug": "minecraft-horse-donkey-names",
      "url": "/pop-culture/minecraft-horse-donkey-names"
    },
    {
      "name": "Llamas",
      "fullName": "Llamas",
      "slug": "minecraft-llama-names",
      "url": "/pop-culture/minecraft-llama-names"
    },
    {
      "name": "Mooshrooms",
      "fullName": "Mooshrooms",
      "slug": "minecraft-mooshroom-names",
      "url": "/pop-culture/minecraft-mooshroom-names"
    },
    {
      "name": "Illagers & Ravagers",
      "fullName": "Illagers & Ravagers",
      "slug": "minecraft-illager-ravager-names",
      "url": "/pop-culture/minecraft-illager-ravager-names"
    },
    {
      "name": "Iron Golems",
      "fullName": "Iron Golems",
      "slug": "minecraft-iron-golem-names",
      "url": "/pop-culture/minecraft-iron-golem-names"
    },
    {
      "name": "Pandas",
      "fullName": "Pandas",
      "slug": "minecraft-panda-names",
      "url": "/pop-culture/minecraft-panda-names"
    },
    {
      "name": "Parrots",
      "fullName": "Parrots",
      "slug": "minecraft-parrot-names",
      "url": "/pop-culture/minecraft-parrot-names"
    },
    {
      "name": "Phantoms",
      "fullName": "Phantoms",
      "slug": "minecraft-phantom-names",
      "url": "/pop-culture/minecraft-phantom-names"
    },
    {
      "name": "Pigs",
      "fullName": "Pigs",
      "slug": "minecraft-pig-names",
      "url": "/pop-culture/minecraft-pig-names"
    },
    {
      "name": "Polar Bears",
      "fullName": "Polar Bears",
      "slug": "minecraft-polar-bear-names",
      "url": "/pop-culture/minecraft-polar-bear-names"
    },
    {
      "name": "Rabbits",
      "fullName": "Rabbits",
      "slug": "minecraft-rabbit-names",
      "url": "/pop-culture/minecraft-rabbit-names"
    },
    {
      "name": "Sheep",
      "fullName": "Sheep",
      "slug": "minecraft-sheep-names",
      "url": "/pop-culture/minecraft-sheep-names"
    },
    {
      "name": "Skeletons",
      "fullName": "Skeletons",
      "slug": "minecraft-skeleton-names",
      "url": "/pop-culture/minecraft-skeleton-names"
    },
    {
      "name": "Skeleton Horses",
      "fullName": "Skeleton Horses",
      "slug": "minecraft-skeleton-horse-names",
      "url": "/pop-culture/minecraft-skeleton-horse-names"
    },
    {
      "name": "Slimes & Magma Cubes",
      "fullName": "Slimes & Magma Cubes",
      "slug": "minecraft-slime-names",
      "url": "/pop-culture/minecraft-slime-names"
    },
    {
      "name": "Snow Golems",
      "fullName": "Snow Golems",
      "slug": "minecraft-snow-golem-names",
      "url": "/pop-culture/minecraft-snow-golem-names"
    },
    {
      "name": "Spiders",
      "fullName": "Spiders",
      "slug": "minecraft-spider-names",
      "url": "/pop-culture/minecraft-spider-names"
    },
    {
      "name": "Squid",
      "fullName": "Squid",
      "slug": "minecraft-squid-names",
      "url": "/pop-culture/minecraft-squid-names"
    },
    {
      "name": "Turtles",
      "fullName": "Turtles",
      "slug": "minecraft-turtle-names",
      "url": "/pop-culture/minecraft-turtle-names"
    },
    {
      "name": "Villagers",
      "fullName": "Villagers",
      "slug": "minecraft-villager-names",
      "url": "/pop-culture/minecraft-villager-names"
    },
    {
      "name": "Witches",
      "fullName": "Witches",
      "slug": "minecraft-witch-names",
      "url": "/pop-culture/minecraft-witch-names"
    },
    {
      "name": "Wither (Skeletons)",
      "fullName": "Wither (Skeletons)",
      "slug": "minecraft-wither-skeleton-names",
      "url": "/pop-culture/minecraft-wither-skeleton-names"
    },
    {
      "name": "Wolves",
      "fullName": "Wolves",
      "slug": "minecraft-wolf-names",
      "url": "/pop-culture/minecraft-wolf-names"
    },
    {
      "name": "Zombies",
      "fullName": "Zombies",
      "slug": "minecraft-zombie-names",
      "url": "/pop-culture/minecraft-zombie-names"
    },
    {
      "name": "Zombie Pigmen",
      "fullName": "Zombie Pigmen",
      "slug": "minecraft-zombie-pigman-names",
      "url": "/pop-culture/minecraft-zombie-pigman-names"
    }
  ],
  "hellaverse-demon-names": [
    {
      "name": "Angels",
      "fullName": "Angels",
      "slug": "hellaverse-angel-names",
      "url": "/pop-culture/hellaverse-angel-names"
    },
    {
      "name": "Demons",
      "fullName": "Demons",
      "slug": "hellaverse-demon-names",
      "url": "/pop-culture/hellaverse-demon-names"
    },
    {
      "name": "Cherubs",
      "fullName": "Cherubs",
      "slug": "hellaverse-cherub-names",
      "url": "/pop-culture/hellaverse-cherub-names"
    },
    {
      "name": "Humans",
      "fullName": "Humans",
      "slug": "hellaverse-human-names",
      "url": "/pop-culture/hellaverse-human-names"
    }
  ],
  "monster-hunter-elder-dragon-names": [
    {
      "name": "Bird & Flying Wyverns",
      "fullName": "Bird & Flying Wyverns",
      "slug": "monster-hunter-flying-wyvern-names",
      "url": "/pop-culture/monster-hunter-flying-wyvern-names"
    },
    {
      "name": "Brute & Fanged Wyverns",
      "fullName": "Brute & Fanged Wyverns",
      "slug": "monster-hunter-brute-wyvern-names",
      "url": "/pop-culture/monster-hunter-brute-wyvern-names"
    },
    {
      "name": "Elder Dragons",
      "fullName": "Elder Dragons",
      "slug": "monster-hunter-elder-dragon-names",
      "url": "/pop-culture/monster-hunter-elder-dragon-names"
    },
    {
      "name": "Fanged Beasts",
      "fullName": "Fanged Beasts",
      "slug": "monster-hunter-fanged-beast-names",
      "url": "/pop-culture/monster-hunter-fanged-beast-names"
    },
    {
      "name": "Herbivores",
      "fullName": "Herbivores",
      "slug": "monster-hunter-herbivore-names",
      "url": "/pop-culture/monster-hunter-herbivore-names"
    },
    {
      "name": "Humans",
      "fullName": "Humans",
      "slug": "monster-hunter-human-names",
      "url": "/pop-culture/monster-hunter-human-names"
    },
    {
      "name": "Leviathans",
      "fullName": "Leviathans",
      "slug": "monster-hunter-leviathan-names",
      "url": "/pop-culture/monster-hunter-leviathan-names"
    },
    {
      "name": "Wingdrakes",
      "fullName": "Wingdrakes",
      "slug": "monster-hunter-wingdrake-names",
      "url": "/pop-culture/monster-hunter-wingdrake-names"
    },
    {
      "name": "Wyverian",
      "fullName": "Wyverian",
      "slug": "monster-hunter-wyverian-names",
      "url": "/pop-culture/monster-hunter-wyverian-names"
    }
  ],
  "league-of-legends-celestial-dragon-names": [
    {
      "name": "Celestial Dragon",
      "fullName": "Celestial Dragon",
      "slug": "league-of-legends-celestial-dragon-names",
      "url": "/pop-culture/league-of-legends-celestial-dragon-names"
    },
    {
      "name": "Minotaur",
      "fullName": "Minotaur",
      "slug": "league-of-legends-minotaur-names",
      "url": "/pop-culture/league-of-legends-minotaur-names"
    },
    {
      "name": "Terrestrial Dragon",
      "fullName": "Terrestrial Dragon",
      "slug": "league-of-legends-terrestrial-dragon-names",
      "url": "/pop-culture/league-of-legends-terrestrial-dragon-names"
    },
    {
      "name": "Troll",
      "fullName": "Troll",
      "slug": "league-of-legends-troll-names",
      "url": "/pop-culture/league-of-legends-troll-names"
    },
    {
      "name": "Demacia",
      "fullName": "Demacia",
      "slug": "league-of-legends-demacia-names",
      "url": "/pop-culture/league-of-legends-demacia-names"
    },
    {
      "name": "Fae Fawn",
      "fullName": "Fae Fawn",
      "slug": "league-of-legends-fae-fawn-names",
      "url": "/pop-culture/league-of-legends-fae-fawn-names"
    },
    {
      "name": "Freljord",
      "fullName": "Freljord",
      "slug": "league-of-legends-freljord-names",
      "url": "/pop-culture/league-of-legends-freljord-names"
    },
    {
      "name": "Ionia",
      "fullName": "Ionia",
      "slug": "league-of-legends-ionia-names",
      "url": "/pop-culture/league-of-legends-ionia-names"
    },
    {
      "name": "Ixtal",
      "fullName": "Ixtal",
      "slug": "league-of-legends-ixtal-names",
      "url": "/pop-culture/league-of-legends-ixtal-names"
    },
    {
      "name": "Noxus",
      "fullName": "Noxus",
      "slug": "league-of-legends-noxus-names",
      "url": "/pop-culture/league-of-legends-noxus-names"
    },
    {
      "name": "Piltover & Zaun",
      "fullName": "Piltover & Zaun",
      "slug": "league-of-legends-piltover-zaun-names",
      "url": "/pop-culture/league-of-legends-piltover-zaun-names"
    },
    {
      "name": "Shurima",
      "fullName": "Shurima",
      "slug": "league-of-legends-shurima-names",
      "url": "/pop-culture/league-of-legends-shurima-names"
    },
    {
      "name": "Targon",
      "fullName": "Targon",
      "slug": "league-of-legends-targon-names",
      "url": "/pop-culture/league-of-legends-targon-names"
    },
    {
      "name": "Treant",
      "fullName": "Treant",
      "slug": "league-of-legends-treant-names",
      "url": "/pop-culture/league-of-legends-treant-names"
    },
    {
      "name": "Undead",
      "fullName": "Undead",
      "slug": "league-of-legends-undead-names",
      "url": "/pop-culture/league-of-legends-undead-names"
    },
    {
      "name": "Vastaya",
      "fullName": "Vastaya",
      "slug": "league-of-legends-vastaya-names",
      "url": "/pop-culture/league-of-legends-vastaya-names"
    },
    {
      "name": "Voidborn",
      "fullName": "Voidborn",
      "slug": "league-of-legends-voidborn-names",
      "url": "/pop-culture/league-of-legends-voidborn-names"
    },
    {
      "name": "Yordle",
      "fullName": "Yordle",
      "slug": "league-of-legends-yordle-names",
      "url": "/pop-culture/league-of-legends-yordle-names"
    }
  ]
};
